{
  "USD": "USD",
  "GBP": "GBP",
  "EUR": "EUR",
  "AUD": "AUD",
  "general": {
    "login": "Iniciar sesión",
    "name": "Nombre",
    "email-address": "Dirección de correo electrónico",
    "full-name": "Nombre completo",
    "failed": "Error",
    "processing": "Procesando",
    "app-loading": "Cargando aplicación",
    "loading": "Cargando",
    "team-members": "miembros",
    "spaces-available": "espacios disponibles",
    "office-full": "Completo",
    "AM": "AM",
    "PM": "PM",
    "am-only": "Solo mañana",
    "pm-only": "Solo tarde",
    "add": "Añadir",
    "desks-available": "Escritorios disponibles",
    "successfully-logged-out": "Sesión cerrada correctamente",
    "admin": "(Admin)",
    "no-team": "Sin equipo",
    "or": "O",
    "no-department": "-- Sin departamento --",
    "select-department": "-- Seleccionar un departamento --",
    "all-teams": "Todos los equipos",
    "select-team": "-- Seleccionar un equipo --",
    "first-monday": "Primer lunes de",
    "first-day": "Primer día en",
    "how-it-works": "Cómo funciona",
    "description": "Descripción"
  },
  "errors": {
    "email-in-use": {
      "title": "Esa dirección de correo electrónico está en uso.",
      "message": "Si ya se ha registrado pero desea cambiar a Google o Microsoft, contacte a <0>hello@team-today.com</0> y podemos migrar su cuenta"
    },
    "email-exists": {
      "message": "Intente <0>iniciar sesión</0> o contáctenos en <1>hello@team-today.com</1> y podemos ayudarle.",
      "logging-in": "iniciar sesión"
    },
    "company-already-registered": {
      "title": "Su empresa ya tiene una cuenta.",
      "message": "Pida una invitación a otro usuario de su empresa. Si ya tiene una cuenta, intente <0>iniciar sesión</0>.",
      "logging-in": "iniciar sesión"
    },
    "general": {
      "title": "Ha habido un error al registrarse.",
      "message": "Inténtelo de nuevo, si el problema persiste contacte a <0>hello@team-today.com</0> y podemos ayudarle."
    },
    "no-account-registered": {
      "title": "Ha habido un error al registrarse.",
      "message": "Si crees que esto es un error, contacta a <0>hello@team-today.com</0> y podemos ayudarte.",
      "button": "Contactar con soporte"
    },
    "azure": {
      "consent-message": {
        "message-1": "La aplicación necesita el consentimiento de un administrador.",
        "message-2": "Solicite el consentimiento a su administrador de TI."
      },
      "access-denied": {
        "message-1": "Se denegó el acceso.",
        "message-2": "Contacte con su administrador de TI para obtener acceso."
      },
      "not-access-den-and-not-consent": {
        "message-1": "Ha habido un error al iniciar sesión.",
        "message-2": "Por favor inténtelo de nuevo o contacte con soporte."
      }
    }
  },
  "login": {
    "title": "Iniciar sesión",
    "valid-email-address-error": "Por favor introduzca una dirección de correo electrónico válida",
    "enter-password": "Introducir contraseña",
    "signup-with-microsoft": "Registrarse con Microsoft",
    "sync-own-calendars": "Sincronice sus propios calendarios",
    "with-google": "Con Google",
    "with-office365": "Con Office 365",
    "or-login-with-email": "O inicie sesión con correo electrónico",
    "email-address": "Dirección de correo electrónico",
    "password": "Contraseña",
    "repeat-password": "Repetir contraseña",
    "remember": "Recordarme",
    "login": "Iniciar sesión",
    "no-account": "¿No tiene cuenta?",
    "have-an-account": "¿Ya tiene una cuenta?",
    "microsoft": "Microsoft",
    "microsoft-or-google": "Microsoft o Google",
    "email-sent": "Correo electrónico enviado",
    "email-validated": "Correo electrónico validado",
    "email-validation-failed": "Error en la validación del correo",
    "terms-link": {
      "1": "Al registrarse acepta nuestros",
      "2": "Términos de servicio",
      "3": "y",
      "4": "Política de privacidad"
    },
    "marketing-emails": "Recibir correos de marketing",
    "login-failed-with-azure": "Error al iniciar sesión con Azure",
    "login-failed-with-azure-help": "Si el problema persiste, contacte con soporte.",
    "create-account-with-own-password": "Crear cuenta con contraseña propia",
    "company-already-has-account": "Su empresa ya tiene una cuenta",
    "try-another-method": "Intente otro método",
    "not-registered": "La cuenta {{email}} no está registrada en Team Today.",
    "not-registered-no-email": "Su cuenta de Microsoft no está registrada en Team Today.",
    "not-registered-help": "Si su empresa ya usa Team Today, pida a un compañero o a un administrador de TI una invitación, de lo contrario registre una nueva cuenta.",
    "not-registered-assistance": "Si necesita ayuda, contáctenos en <0>hello@team-today.com</0>."
  },
  "register": {
    "title": "Registrarse",
    "best-experience-signup": "Para la mejor experiencia, regístrese con",
    "office365": "Office 365",
    "google": "Google",
    "email": "Correo electrónico",
    "follow-the-link": "Siga el enlace",
    "review-terms": "Revisar términos",
    "terms-accept-message": "Al registrarse, acepta nuestros términos y condiciones",
    "best-experience-use-ms": "Para la mejor experiencia use Microsoft",
    "create-account-with-password": "Crear cuenta con contraseña",
    "register-tnc": "Al registrarse acepta los términos y condiciones",
    "verification-required": "Verificación requerida",
    "check-inbox": "Compruebe su bandeja de entrada",
    "follow-link": "Siga el enlace en el correo para verificar su cuenta",
    "resend-email": "Reenviar correo"
  },
  "teams-register": {
    "title": "Registrarse en Teams",
    "create-account": "Crear cuenta",
    "have-account": "¿Ya tiene cuenta?",
    "list-item-1": "Planifique su semana laboral",
    "list-item-2": "Reserve escritorios y aparcamiento",
    "list-item-3": "Gestione el espacio de oficina",
    "started": "Empezar",
    "": ""
  },
  "forgot-password": {
    "forgot-password": "¿Olvidó su contraseña?",
    "description": "Introduzca su dirección de correo electrónico y le enviaremos un enlace para restablecer su contraseña.",
    "send-password": "Enviar contraseña",
    "request-processing": "Procesando solicitud",
    "follow-link": "Siga el enlace en el correo para restablecer su contraseña",
    "enter-email-address": "Introduzca su dirección de correo electrónico",
    "send-password-reset": "Enviar restablecimiento de contraseña",
    "your-email-address": "Su dirección de correo electrónico"
  },
  "reset-password": {
    "stale-token": "El enlace ha expirado",
    "success": "Contraseña restablecida correctamente",
    "forgot-password": "Olvidé mi contraseña",
    "go-to-login": "Ir a iniciar sesión",
    "try-requesting-new-email-reset": "Intente solicitar un nuevo restablecimiento por correo",
    "request-new-email-reset": "Solicitar nuevo restablecimiento",
    "new-pass": "Nueva contraseña",
    "repeat-new-pass": "Repetir nueva contraseña",
    "reset-pass": "Restablecer contraseña",
    "reset-pass-to-login": "Restablecer contraseña e iniciar sesión",
    "passwords-not-match": "Las contraseñas no coinciden",
    "passwords-not-blank": "Las contraseñas no pueden estar vacías"
  },
  "invite": {
    "title": "Invitación",
    "passwords-mismatch": "Las contraseñas no coinciden",
    "failed": "Error en la invitación",
    "register-failed": "Error en el registro",
    "tandc": "Términos y condiciones",
    "issues": "¿Problemas?",
    "create-account-with-password": "Crear cuenta con contraseña"
  },
  "team-view": {
    "team-view": "Vista de equipo",
    "whereabouts-report": "Mi informe de ubicación",
    "whereabouts": "Ubicaciones",
    "edit-whereabouts": "Editar ubicaciones",
    "set-whereabouts": "Establecer ubicaciones",
    "teams": "Equipos",
    "offices": "Oficinas",
    "workgroup": "Grupo de trabajo",
    "departments": "Departamentos",
    "misc": "Otros"
  },
  "settings": {
    "settings": "Configuración",
    "bookable-areas": "Áreas reservables",
    "desk-booking": "Reserva de escritorios",
    "office-information": "Información de la oficina",
    "office-information-how-it-works": "Las oficinas aparecen para que los usuarios reserven en Team Whereabouts. Puede asignar usuarios a una oficina para que sea su ubicación predeterminada.",
    "desk-bookings-how-it-works": "Las oficinas aparecen para que los usuarios reserven en Team Whereabouts. Puede asignar usuarios a una oficina para que sea su ubicación predeterminada.",
    "button-add-team-member": "Añadir miembro del equipo",
    "button-add-user": "Añadir usuario",
    "edit-office": "Editar oficina",
    "create-new-office": "Crear nueva oficina",
    "edit-past-whereabouts-title": "Editar ubicaciones pasadas",
    "edit-past-whereabouts-enabled-description": "Los usuarios pueden editar sus ubicaciones pasadas",
    "edit-past-whereabouts-disabled-description": "Los usuarios no pueden editar sus ubicaciones pasadas",
    "edit-past-whereabouts-recommendation": "Recomendado: activado",
    "manage-teams-and-users": "Gestionar equipos y usuarios",
    "users-with-no-teams": "Usuarios sin equipo",
    "my-team": "Mi equipo",
    "other-teams": "Otros equipos",
    "personal-pref": "Preferencias personales",
    "personal-pref-desc": "Estas preferencias son solo para ti",
    "email-reminder": "Recordatorio por correo electrónico",
    "email-reminder-desc": "Un correo electrónico semanal para recordarte configurar tus planes para la semana.",
    "calendar-link": "Enlace de calendario",
    "languages": "Idiomas",
    "calendar-link-tip": "¿Sabías que puedes vincular tu calendario de Microsoft 365 o Google? Cuando actualizas dónde trabajas, se puede añadir a tu calendario, así tus compañeros saben dónde estás sin necesidad de una aplicación.",
    "calendar-link-desc": "Activar sincronización de calendario. Controla si tus actualizaciones de ubicación se envían a tu calendario.",
    "marketing-emails": "Correos de marketing",
    "marketing-emails-desc": "Recibir ocasionalmente correos electrónicos de Team Today.",
    "fav-office": "Oficina favorita",
    "assigned-desk": "Asignado",
    "billing-header": "Facturación",
    "payment-details": "Detalles de pago",
    "cancel-message": "Sus datos de pago se gestionan por un gestor de cuenta; para actualizarlos o cambiarlos, contáctenos en <strong><0>support@team-today.com</0></strong>",
    "account-usage": "Gestione su plan de suscripción, licencias e información de facturación.",
    "users-registered": "Usuarios registrados",
    "spaces-left": "Espacios restantes",
    "teams-in-use": "Equipos en uso",
    "car-parking": "Aparcamiento",
    "car-parking-how-it-works": "Aparcamiento de la oficina, contáctenos para gestionar plazas de aparcamiento con un mapa interactivo.",
    "automatic-checkin": "Check-in automático",
    "teams-left": "Equipos restantes",
    "member-limit-reached": "Límite de miembros alcanzado",
    "account-full-in-teams": "La cuenta está llena en Teams",
    "account-full-normal": "La cuenta está llena",
    "holiday-rules": "Reglas de vacaciones",
    "holiday-year-start-message": "Fecha de inicio del año de vacaciones",
    "all-users-have-team": "Todos los usuarios tienen equipo",
    "setup-a-company": "Configurar una empresa",
    "company-name": "Nombre de la empresa",
    "create-floor-plan": "Crear plano de planta",
    "create-floor-plan-description": "Cree un plano interactivo para que los usuarios reserven escritorios.",
    "create-floor-plan-instructions": "Contacte con nosotros para configurar su plano de planta.",
    "users-reporting-to-this-user": "Usuarios que reportan a este usuario",
    "line-reports": "Informes de línea",
    "indirect-line-reports": "Informes de línea indirectos",
    "no-line-reports": "Sin informes de línea",
    "office-management": "Gestión de oficinas",
    "set-limits-on-offices": "Establecer límites en oficinas",
    "offices": "Oficinas",
    "office-floor": "Planta de oficina",
    "manage-office-locations-title": "Gestionar ubicaciones de oficina",
    "manage-office-locations-description": "Gestione y configure las ubicaciones de sus oficinas.",
    "assign-users": "Asignar usuarios",
    "users-not-in-team": "Usuarios sin equipo",
    "locked-signup-domains": {
      "title": "Dominios bloqueados",
      "subtitle": "Evite que personas de su empresa creen una cuenta de Team Today aparte. Quien se registre con uno de estos dominios verá que su empresa ya tiene una cuenta y deberá pedir una invitación a un compañero. Los usuarios invitados pueden unirse con normalidad.",
      "approval-note": "El equipo de Team Today revisa los nuevos dominios antes de que entren en vigor. Suele tardar un día laborable.",
      "placeholder": "p. ej. suempresa.com",
      "add": "Añadir dominio",
      "remove": "Eliminar",
      "empty": "Todavía no se han añadido dominios.",
      "status-active": "Activo",
      "status-pending": "Pendiente de aprobación",
      "status-rejected": "No aprobado",
      "rejected-help": "No pudimos confirmar que su empresa sea propietaria de este dominio. Contacte con support@team-today.com si cree que es un error.",
      "remove-confirm": "¿Eliminar {{domain}}? Las personas con este dominio de correo podrán volver a crear una cuenta nueva.",
      "add-failed": "No se pudo añadir ese dominio.",
      "remove-failed": "No se pudo eliminar ese dominio."
    },
    "domain-based-signup": {
      "title": "Registro basado en dominio",
      "subtitle": "Permita que cualquier persona con un dominio de correo específico se registre",
      "everyone": "Todos",
      "enabled-message": "Cualquier persona que se registre con una dirección de correo que termine en <0>{{domainName}}</0> se añadirá de inmediato a su cuenta. Simplemente hábleles de Team Today y pídales que creen una cuenta.",
      "enabled-message-multiple": "Cualquier persona que se registre con una dirección de correo que termine en uno de estos dominios, <0>{{domains}}</0>, se añadirá de inmediato a su cuenta. Simplemente hábleles de Team Today y pídales que creen una cuenta.",
      "disabled-message": "Cualquier persona que se registre con una dirección de correo que termine en <0>su nombre de dominio</0> se añadirá de inmediato a su cuenta. Simplemente hábleles de Team Today y pídales que creen una cuenta.",
      "your-domain-name": "su nombre de dominio",
      "domains-title": "Dominios vinculados",
      "approval-note": "Añada todos los dominios de correo que utiliza su empresa. El equipo de Team Today revisa cada uno antes de que entre en vigor, normalmente en un día laborable.",
      "placeholder": "p. ej. suempresa.com",
      "add": "Añadir dominio",
      "remove": "Eliminar",
      "empty": "Aún no hay dominios vinculados. Añada el dominio de correo de su empresa para empezar.",
      "status-active": "Activo",
      "status-pending": "Pendiente de aprobación",
      "status-rejected": "No aprobado",
      "rejected-help": "No pudimos confirmar que su empresa sea propietaria de este dominio. Contacte con support@team-today.com si cree que es un error.",
      "remove-confirm": "¿Eliminar {{domain}}? Las personas con este dominio de correo ya no se unirán a su cuenta automáticamente.",
      "add-failed": "No se pudo añadir ese dominio.",
      "remove-failed": "No se pudo eliminar ese dominio.",
      "switch-off-note": "Active el interruptor de arriba para que estos dominios entren en vigor.",
      "pending-line-1": "Pendiente de verificación",
      "pending-line-2": "Le hemos enviado un correo de verificación",
      "pending-line-3": "Haga clic en el enlace del correo para verificar",
      "pending-line-4": "Si no recibió el correo, contacte con soporte",
      "active-line-1": "El dominio está verificado",
      "active-line-2": "Los usuarios pueden registrarse con este dominio",
      "active-line-3": "Los nuevos usuarios se añadirán a su empresa"
    },
    "private-groups": {
      "title": "Grupos privados",
      "subtitle": "Hacer que los equipos sean privados por defecto"
    },
    "schengen": {
      "title": "Seguimiento Schengen",
      "subtitle": "Realice un seguimiento del número de días que las personas pasan en el espacio Schengen"
    },
    "whereabouts-reminder-config": {
      "title": "Configuración de recordatorios de ubicación",
      "subtitle": "Envíe recordatorios semanales a los usuarios en Microsoft Teams para establecer su ubicación.",
      "day": "Día de envío del recordatorio",
      "day-placeholder": "Día de envío",
      "hour": "Hora de envío del recordatorio",
      "hour-placeholder": "Hora de envío",
      "timezone": "Zona horaria",
      "timezone-placeholder": "Zona horaria",
      "enable": "Activar"
    },
    "restrict-team-management": {
      "title": "Restringir gestión de equipos",
      "subtitle": "Solo los administradores pueden gestionar equipos"
    },
    "show-birthdays": {
      "title": "Mostrar cumpleaños",
      "subtitle": "Mostrar los cumpleaños de los miembros del equipo"
    },
    "azure-scim": {
      "medium": "Medio",
      "title": "Aprovisionamiento Azure SCIM",
      "scim-integration": "Configuración de integración SCIM",
      "scim-endpoint": "Punto de conexión SCIM",
      "scim-endpoint-description": "Introdúzcalo como URL del inquilino (Tenant URL) al configurar el aprovisionamiento en Microsoft Entra ID y use una clave API de SCIM como token secreto (Secret Token).",
      "subtitle": "Sincronice usuarios y grupos desde Azure AD",
      "description": "Configure el aprovisionamiento SCIM para sincronizar automáticamente usuarios.",
      "line-1": "Sincronización automática de usuarios",
      "line-2": "Sincronización de grupos y departamentos",
      "line-3": "Desaprovisionamiento automático",
      "enabled-departments": "Departamentos activados",
      "enabled-departments-description": "Sincronizar departamentos desde Azure AD.",
      "enabled-departments-description-2": "Activar esto evitará que los departamentos se gestionen en Team Today ya que las actualizaciones vendrán a través de SCIM.",
      "disable-welcome-email": "Desactivar correo de bienvenida",
      "disable-welcome-email-description": "No enviar correos de bienvenida a usuarios aprovisionados por SCIM",
      "disable-new-user-access": "Desactivar acceso de nuevos usuarios",
      "disable-new-user-access-description": "Los nuevos usuarios aprovisionados no tendrán acceso hasta que se active manualmente"
    },
    "spreadsheet": {
      "trial": "Prueba",
      "title": "Importar usuarios por hoja de cálculo",
      "subtitle": "Importe usuarios desde un archivo de hoja de cálculo",
      "description": "Suba un archivo CSV o Excel para importar usuarios en masa."
    },
    "holiday-approval": {
      "title": "Aprobación de vacaciones",
      "message": "Requerir aprobación del gerente para las solicitudes de vacaciones"
    },
    "holiday-tracking": {
      "title": "Seguimiento de vacaciones",
      "message": "Activar seguimiento y gestión de vacaciones"
    },
    "line-management": {
      "title": "Gestión de línea",
      "enabled-message": "La gestión de línea está activada",
      "disabled-message": "La gestión de línea está desactivada"
    },
    "seven-day": {
      "title": "Semana de 7 días",
      "enabled-message": "La semana de 7 días está activada",
      "disabled-message": "La semana de 7 días está desactivada"
    },
    "weekly-notes": {
      "title": "Notas semanales",
      "enabled-message": "Las notas semanales están activadas",
      "disabled-message": "Las notas semanales están desactivadas"
    },
    "global-email-setting": {
      "title": "Configuración global de correo",
      "all-users": "Todos los usuarios",
      "no-users": "Ningún usuario",
      "users-choice": "Elección del usuario",
      "description": "Configurar los correos de recordatorio para todos los usuarios"
    },
    "icon-pack": {
      "title": "Paquete de iconos",
      "description": "Elija el estilo de iconos para su empresa",
      "standard": "Estándar",
      "basic": "Básico"
    },
    "tenant-based": {
      "title": "Inicio de sesión basado en inquilino",
      "message-1": "Vincular su cuenta de Azure a Team Today",
      "message-2": "Esto permite el inicio de sesión automático para todos los usuarios de su organización",
      "active-1": "El vínculo con Azure está activo",
      "active-2": "Los usuarios pueden iniciar sesión automáticamente",
      "active-3": "ID de inquilino vinculado"
    },
    "hot-desking-page": {
      "title": "Reserva de escritorios",
      "message-1": "Permita a los miembros del equipo reservar escritorios",
      "message-2": "Cree plantas y áreas con escritorios disponibles",
      "message-3": "Los usuarios pueden reservar un escritorio al establecer su ubicación",
      "message-4": "Añada un plano interactivo para una mejor experiencia",
      "button": "Configurar reserva de escritorios"
    },
    "editing-future-whereabouts": {
      "repeat-weekly-schedule": "Repetir horario semanal",
      "repeat-weekly-schedule-description": "Permita a los usuarios repetir su horario semanal",
      "schedules": "Horarios",
      "number-of-weeks": "Número de semanas",
      "applies-to-team-admins": "Se aplica a administradores de equipo",
      "applies-to-standard-users": "Se aplica a usuarios estándar",
      "number-of-weeks-description": "Número de semanas que los usuarios pueden configurar con antelación"
    },
    "approvals": {
      "title": "Aprobaciones",
      "do-holidays-require-approval": "¿Las vacaciones requieren aprobación?",
      "how-it-works": "Cómo funciona",
      "create-line-managers-message-1": "Cree gerentes de línea para gestionar aprobaciones",
      "create-line-managers-message-2": "Los gerentes recibirán notificaciones de solicitudes",
      "create-line-managers-message-3": "Pueden aprobar o rechazar desde la aplicación",
      "please-note": "Tenga en cuenta",
      "please-note-message-1": "Los administradores de empresa pueden aprobar todas las solicitudes",
      "company-admins": "Administradores de empresa",
      "please-note-message-2": "Las solicitudes pendientes se aprobarán automáticamente si no hay gerente asignado",
      "approvals-disabled-title": "Aprobaciones desactivadas",
      "approvals-disabled-description": "Las solicitudes de vacaciones no requieren aprobación"
    },
    "holiday-allowance": {
      "title": "Asignación de vacaciones",
      "message-1": "Establezca la asignación de vacaciones por defecto para todos los usuarios",
      "please-note": "Tenga en cuenta",
      "message-2": "Puede establecer asignaciones individuales editando un usuario",
      "zero": "0",
      "edit-individual-allowances": "Editar asignaciones individuales"
    },
    "carry-over": {
      "title": "Activar traspaso automático",
      "description": "Traspasa automáticamente las vacaciones del año anterior",
      "carry-over-days": "Traspaso máximo",
      "rules-title": "Añadir reglas de vencimiento",
      "rules-description": "Establezca una regla para que los días traspasados se utilicen antes de una fecha determinada",
      "expires-on": "El traspaso vence el"
    },
    "holiday-setting": {
      "year": "Año",
      "month": "Mes"
    },
    "manage-area": {
      "create-area": "Crear área",
      "name": "Nombre",
      "message-1": "Las áreas agrupan escritorios en una planta",
      "message-2": "Los usuarios pueden elegir un área al reservar",
      "number-of-desks": "Número de escritorios"
    },
    "manage-desk": {
      "create-desk": "Crear escritorio",
      "message-1": "Los escritorios se crean dentro de un área o planta",
      "message-2": "Los usuarios reservan escritorios individuales",
      "number-of-desks": "Número de escritorios",
      "floor-plans-enabled": "Planos de planta activados",
      "contact-us-to-change": "Contáctenos para cambiar",
      "desk-name": "Nombre del escritorio"
    },
    "manage-hospitality": {
      "title": "Gestionar hospitalidad",
      "enable-hospitality": "Activar hospitalidad",
      "add-new-item": "Añadir artículo de hospitalidad",
      "add-people-to-notify": "Añadir personas a notificar",
      "important-note": "Sin nota importante establecida",
      "important-note-title": "Notas importantes de hospitalidad (visibles para empleados)",
      "notifications": "Notificaciones",
      "add-people-message": "Añada personas (ej. asistentes de oficina) a notificar cuando se envíe una solicitud de hospitalidad.",
      "number-of-people-notifying": "Notificando a {{count}} personas.",
      "hospitality-description": "Añada artículos (ej. catering) que los empleados pueden solicitar para salas de reuniones.",
      "menu-item": "Artículo del menú",
      "availability": "Disponibilidad",
      "item-name": "Nombre del artículo",
      "notes": "Notas",
      "price": "Precio",
      "currency": "Moneda",
      "add-hospitality-item": "Añadir artículo de hospitalidad",
      "edit-important-note": "Editar nota importante"
    },
    "visitor-booking": {
      "title": "Reserva de visitantes",
      "heading": "Gestión de visitantes",
      "upsell": "La reserva de visitantes está disponible en los planes Premium y Enterprise.",
      "upsell-link": "Mejora tu plan",
      "not-enabled": "Esta función no está habilitada en tu cuenta. Contacta con"
    },
    "manage-office": {
      "title": "Gestionar oficina",
      "message": "Configure las opciones de su oficina",
      "another-floor": "Otra planta",
      "additional-access-required": "Acceso adicional requerido",
      "company-admin-only": "Solo administradores de empresa",
      "nosetup": "Sin configuración",
      "no-setup-message-1": "Esta oficina aún no se ha configurado",
      "no-setup-message-2": "Añada plantas y escritorios para empezar",
      "no-setup-message-3": "Los usuarios podrán reservar escritorios cuando se configuren",
      "enable-car-parking": "Activar aparcamiento",
      "car-parking-capacity": "Capacidad de aparcamiento",
      "desk-booking-window-title": "Ventana de reserva de escritorios",
      "desk-booking-window-description": "Cuántas semanas de antelación pueden reservar los usuarios",
      "desk-booking-window-weeks": "semanas",
      "desk-booking-window-opens-description": "Elija cuándo se abre la siguiente semana de reservas. Toda la semana se abre en ese momento.",
      "desk-booking-window-open-day": "Se abre el",
      "desk-booking-window-open-time": "Se abre a las",
      "desk-booking-window-timezone": "Zona horaria",
      "desk-booking-window-unit": "Contar la ventana en",
      "desk-booking-window-unit-weeks": "Semanas",
      "desk-booking-window-unit-days": "Días",
      "desk-booking-window-unit-workdays": "Días laborables (lun. a vie.)",
      "desk-booking-window-days": "Número de días que los usuarios pueden reservar con antelación",
      "desk-booking-window-workdays": "Número de días laborables que los usuarios pueden reservar con antelación",
      "desk-booking-window-opens-daily-description": "Elija la hora a la que se abre cada día el día siguiente.",
      "desk-booking-window-max-days": "La ventana de reserva no puede superar los {{max}} días"
    },
    "meeting-rooms": {
      "manage-meeting-rooms": "Gestionar salas de reuniones",
      "add-meeting-rooms": "Añadir una sala de reuniones",
      "create": "Crear",
      "meeting-room": "sala de reuniones",
      "name": "Nombre",
      "meeting-room-email-address": "Dirección de correo de la sala",
      "important": "Importante",
      "important-message": "La dirección de correo debe ser una sala de recursos de Microsoft 365",
      "capacity": "Capacidad",
      "office": "Oficina",
      "floor": "Planta",
      "edit": "Editar",
      "limit-title": "Límite alcanzado",
      "limit-description": "Ha alcanzado el número máximo de salas de reuniones",
      "microsoft-link": "Vínculo de Microsoft",
      "microsoft-link-description": "Vincule una sala de recursos de Microsoft 365 para sincronización bidireccional",
      "introduction": {
        "how": "Cómo",
        "intro": "Introducción a las salas de reuniones",
        "intro-1": "Cree salas de reuniones para que los miembros del equipo las reserven",
        "intro-2": "Vincule con Microsoft 365 para sincronización bidireccional",
        "intro-3": "Añada instalaciones como TV, pizarra, etc."
      }
    },
    "looking-after-multiple-teams": "¿Gestionando múltiples equipos?",
    "create-a-company": "Crear una empresa",
    "departments": {
      "title": "Departamentos",
      "add-new": "Añadir nuevo",
      "add-members": "Añadir nuevos miembros"
    },
    "notify-manager-on-leave-cancellation": {
      "title": "Cancellation notifications",
      "subtitle": "When enabled, a user's line manager is emailed when the user cancels their own approved leave (holiday or any approval-required leave type)."
    }
  },
  "edit-workgroup": {
    "edit-workgroup": "Editar grupo de trabajo",
    "edit-workgroup-name": "Editar nombre del grupo de trabajo",
    "add-or-remove-members": "Añadir o eliminar miembros",
    "add-users-to-group": "Añadir usuarios al grupo",
    "select-users-to-add": "Seleccionar usuarios para añadir"
  },
  "week-notes": {
    "week-notes": "Notas semanales",
    "must-be-in-team": "Debes pertenecer a un equipo para establecer una nota semanal",
    "save-failed": "Error al guardar la nota semanal. Por favor, inténtalo de nuevo."
  },
  "personal-perf": {
    "personal-perf": "Preferencias personales",
    "office-perf": "Preferencias de oficina",
    "other-perf": "Otras preferencias",
    "default-office-and-location": "Oficina y ubicación predeterminadas",
    "default-office-title": "Oficina predeterminada",
    "default-office-description": "Establezca su oficina predeterminada para una reserva más rápida",
    "require-space-title": "Necesita espacio de aparcamiento",
    "require-space-description": "¿Necesita una plaza de aparcamiento regularmente?",
    "veh-registration": "Matrícula del vehículo",
    "veh-colour": "Color del vehículo",
    "veh-make": "Marca del vehículo",
    "office-tab": "Oficina",
    "notifications-tab": "Notificaciones",
    "calendar-tab": "Sincronización del calendario",
    "birthday-tab": "Cumpleaños",
    "language-tab": "Idioma"
  },
  "approvals": {
    "approvals-title": "Aprobaciones de vacaciones",
    "approved": "Aprobado",
    "cancelled": "Cancelado",
    "days": "Días",
    "declined": "Rechazado",
    "holiday-approvals": "Aprobaciones de vacaciones",
    "no-results-found": "No se encontraron resultados",
    "no-approvals-found": "No se encontraron aprobaciones"
  },
  "work-planner": {
    "work-planner": "Planificador de trabajo",
    "show-other-teams": "Mostrar otros equipos",
    "events-and-projects": "Eventos y proyectos",
    "add-event-project": "Añadir evento/proyecto",
    "create-event-title": "Crear evento",
    "event-is-for": "El evento / proyecto es para",
    "select-teams-to-follow": "Seleccionar equipos a seguir",
    "select-teams-to-follow-description": "Elija los equipos que desea ver en su planificador",
    "select-teams-to-follow-error": "Seleccione al menos un equipo"
  },
  "textinput": {
    "from": "Desde",
    "date": "Fecha",
    "to": "Hasta",
    "firstname": "Nombre",
    "lastname": "Apellido",
    "office-location": "Ubicación de oficina (opcional)",
    "jobTitle": "Cargo",
    "email": "Correo electrónico",
    "password": "Contraseña",
    "repeat-password": "Repetir contraseña",
    "office-name": "Nombre de la oficina",
    "office-postcode": "Código postal de la oficina",
    "desks-available": "Escritorios disponibles",
    "number-desks-available": "Número de escritorios disponibles",
    "number-desks-for-floor": "Número de escritorios para la planta",
    "desks-available-each-day": "Escritorios disponibles cada día",
    "floor-name": "Nombre de la planta",
    "add-individual-desks": "Añadir escritorios individuales",
    "areas-names-and-avail": "Nombres de áreas y disponibilidad",
    "desk-names-and-avail": "Nombres de escritorios y disponibilidad",
    "search-existing-user": "Buscar usuario existente",
    "whereabouts-name": "Nombre de ubicación",
    "holiday-title-or-reason": "Título o motivo de vacaciones",
    "company-settings": "Configuración de la empresa",
    "team-name": "Nombre del equipo",
    "enable-desk-booking": "Activar reserva de escritorios",
    "enable-car-parking": "Activar aparcamiento",
    "add-date": "Añadir fecha",
    "select-placeholder": "Seleccionar...",
    "search": "Buscar",
    "select-start-day": "Seleccionar día de inicio",
    "find-user": "Buscar usuario",
    "mac-address-placeholder": "ej. AA:BB:CC:DD:EE:FF",
    "network-name-placeholder": "ej. Oficina-WiFi",
    "ip-address-placeholder": "ej. 203.0.113.10",
    "select-desk": "Seleccionar escritorio",
    "none-available": "Ninguno disponible",
    "select-month": "Seleccionar mes",
    "choose-an-office": "Elegir una oficina",
    "filter-users": "Filtrar usuarios",
    "please-select": "Por favor seleccione",
    "select-team": "Seleccionar equipo",
    "office-three-letter-code": "Código de 3 letras de la oficina"
  },
  "button": {
    "add-new-space": "Añadir nuevo espacio",
    "filters": "Filters",
    "setup-offices": "Set up offices",
    "change-office": "Change office",
    "choose-day": "Choose a day",
    "show-more": "Mostrar más",
    "show-less": "Mostrar menos",
    "save-changes": "Save changes",
    "back-and-change": "Go back and change",
    "view-whereabouts-report": "View My Whereabouts Report",
    "continue": "Continue",
    "done": "Done",
    "update": "Update",
    "edit": "Editar",
    "reset-to-current-week": "Reset to current week",
    "view-floor-plan": "View floor plan",
    "your-holidays": "Leave Planner",
    "requests": "Approvals",
    "team-holidays": "Team holidays",
    "approvals-required": "Approvals Required",
    "view-approvals": "Approvals",
    "team-view": "Team View",
    "back-to-team-view": "Back to team view",
    "settings": "Settings",
    "company-view": "Company View",
    "my-requests": "My requests",
    "work-planner": "Work Planner",
    "my-holiday-requests": "My holiday requests",
    "holiday-requests": "Holiday Requests",
    "office-view": "Office View",
    "all-teams": "All teams",
    "floor-plan": "Floor Plan",
    "yes": "Sí",
    "create-new-work-group": "Create a new work group",
    "create-new-team": "Create a new team",
    "create-new-group": "Create a new group",
    "create-new-department": "Create a new department",
    "link-team-or-workgroup": "Link Team or Group to office",
    "finish-setting-up-your-account": "Finish setting up your account",
    "filter-by-office": "Filter Teams and work groups by Office",
    "save-whereabouts": "Save whereabouts",
    "clear-day": "Clear day",
    "add-holiday-request": "Add a leave request",
    "add-holiday": "Add Leave",
    "am": "AM",
    "pm": "PM",
    "all-day": "All day",
    "book-holiday": "Request holiday",
    "delete-holiday-request": "Delete holiday request",
    "book-am": "Book AM",
    "book-pm": "Book PM",
    "book-all-day": "Book all day",
    "am-only": "AM only",
    "pm-only": "PM only",
    "login-to-your-account": "Log in to your account",
    "continue-to-signup": "Continue to sign up",
    "user-view": "User view",
    "tag-manager": "Workgroup manager",
    "edit-and-manage-team": "Edit and manage team",
    "edit-and-manage-workgroup": "Edit and manage workgroup",
    "edit-and-manage-department": "Edit and manage department",
    "add-another-team": "Add another team",
    "add-another-team-member": "Add another team member",
    "set-up-company-and-add-teams": "Set up company and add teams",
    "add-new-favourite": "Add new favourite",
    "logout": "Logout",
    "move-another-user": "Add another team member",
    "done-for-now": "Done for now",
    "add-to-team": "Add to team",
    "approve": "Approve",
    "decline": "Decline",
    "approved": "Approved",
    "declined": "Declined",
    "pending": "Pending",
    "add-new-tag": "Add new workgroup",
    "edit-tags": "Edit workgroups",
    "setup-multiple-offices": "Set up multiple offices",
    "delete-office": "Delete office",
    "add-new-desk": "Add new desk",
    "add-new-area": "Add new area",
    "send-invite": "Send invite",
    "add-team-member": "Add team member",
    "delete-team": "Delete Team?",
    "download-csv": "Download .csv",
    "download-excel": "Export to Excel",
    "send-reminder": "Send reminder",
    "retry": "Retry",
    "go-back": "Go back",
    "finish-and-save": "Finish and save",
    "add-members": "Add members",
    "close": "Cerrar",
    "add-team-members": "Add team members",
    "add-later": "I'll do this later",
    "upgrade": "Upgrade my account",
    "create": "Create",
    "checkout": "Checkout",
    "monthly": "Monthly",
    "yearly": "Yearly",
    "confirm": "Confirmar",
    "save": "Guardar",
    "confirm-delete-team": "Yes, delete team",
    "reject-delete-team": "No don't remove team",
    "create-company": "Create company",
    "setup-more-teams": "Setup some other teams",
    "ok": "OK",
    "fetch-users-from-microsoft": "Fetch users from microsoft",
    "add-company-holiday": "Add a company holiday",
    "got-it": "Got it",
    "confirm-delete-user": "Yes, delete user",
    "reject-delete-user": "No don't remove user",
    "lets-go": "Lets go",
    "create-office": "Create office",
    "EDIT": "EDIT",
    "add-another-holiday": "Add another holiday",
    "upgrade-my-account": "Upgrade my account",
    "view-report": "View report",
    "yes-delete": "Yes, delete.",
    "cancel": "Cancelar",
    "delete-user": "Delete user",
    "change": "Change",
    "edit-office": "Edit office",
    "create-new-office": "Create new office",
    "add-bookable-area": "Add a bookable area",
    "add-new-line-report": "Add new line report",
    "assign-users-to-team": "Assign users to teams",
    "full": "Full",
    "free": "Free",
    "partial": "Partial",
    "not-available": "Not available",
    "oof": "Out of office",
    "working-elsewhere": "Working elsewhere",
    "delete": "Eliminar",
    "save-company-holiday": "Save company holiday",
    "delete-holiday": "Delete holiday",
    "delete-account": "Remove all teams and data",
    "book": "Book",
    "view": "View",
    "delete-event-project": "Delete event",
    "view-subscription": "Administrar método de pago",
    "create-subscription": "Create a subscription",
    "try-again": "Try again",
    "week-view": "Vista semanal",
    "month-view": "Month view",
    "year-view": "Year view",
    "download-office-attendees": "Download office report (.xls)",
    "download-car-park-attendees": "Download car park report (.xls)",
    "team-report": "Team report",
    "workgroup-report": "Informe de grupo de trabajo",
    "department-report": "Department report",
    "user-report": "User report",
    "create-team": "Create team",
    "turn-on-in-settings": "Turn on in settings",
    "log-in": "Log in",
    "today": "Today"
  },
  "loading": {
    "saving-whereabouts": "Saving whereabouts"
  },
  "View floor plan": "View floor plan",
  "dates": {
    "this-week": "This week"
  },
  "checkbox": {
    "first-aider": "First aider",
    "fire-warden": "Fire warden",
    "mental-first-aider": "Mental Health First aider",
    "key-holder": "Key holder"
  },
  "whereaboutsAvailability": {
    "show-avail-calendar-like": "Show availability on calendar as:",
    "show-as-free": "This will show as <strong>Free</strong> in your calendar.",
    "show-as-tentative": "This will show as <strong>Tentative</strong> in your calendar.",
    "show-as-busy": "This will show as <strong>Busy</strong> in your calendar.",
    "show-as-oof": "This will show as <strong>Out of Office</strong> in your calendar (Outlook only).",
    "show-as-working-elsewhere": "This will show as <strong>Working elsewhere</strong> in your calendar (Outlook only)."
  },
  "company-settings-page": {
    "whereabouts-management-tab": "Gestión de ubicaciones",
    "visitors-tab": "Visitantes",
    "edit-company": "Edit company",
    "company-settings": "Configuración de la empresa",
    "company-preferences": "Company Preferences",
    "edit-global": "Edit global settings",
    "signup-and-register": "Sign Up and Register Settings",
    "azure-and-active-dir-settings": "Azure and Active Directory Settings",
    "other": "Other Settings",
    "notifications": "Configuración de notificaciones",
    "tenant-id": "ID de inquilino de Azure",
    "general": "General",
    "danger-zone": "Zona de peligro",
    "notifications-tab": "Notificaciones",
    "signup-and-register-tab": "Registro e inscripción",
    "azure-configuration": "Configuración de Azure",
    "other-tab": "Otro",
    "api-keys-tab": "API Keys",
    "api-keys": {
      "public-api": {
        "title": "Public API key",
        "description": "Used by external integrations calling the Team Today public API."
      },
      "scim": {
        "title": "SCIM API key",
        "description": "Used by SCIM clients to provision and sync users."
      },
      "no-key": "No key generated yet.",
      "label": "Label",
      "label-placeholder": "e.g. Okta production",
      "unlabeled": "Unlabeled",
      "edit-label": "Edit label",
      "save-label": "Save",
      "cancel": "Cancel",
      "generate": "Generate key",
      "generate-additional": "Generate new key",
      "regenerate": "Regenerate",
      "revoke": "Revoke",
      "copy": "Copy",
      "copied": "Copied!",
      "confirm-regenerate": "This will invalidate the current key. Any integration using it will stop working. Continue?",
      "confirm-revoke": "This will delete the current key. Any integration using it will stop working. Continue?"
    }
  },
  "company-view-page": {
    "workgroups": "Workgroups",
    "choose-office-to-view": "Choose an office",
    "create-an-office": {
      "title": "Create an office",
      "description": "Set a limit to the number of office desks available so colleagues know when to come into the office."
    },
    "sidebar": {
      "create-work-group": "Create a work group?",
      "create-work-group-description": "Create work groups to allow users to exist in more than one team"
    },
    "all-teams": "All Teams",
    "work-groups": "Work Groups",
    "create-new-group": "Create a new group?",
    "create-new-department": "Create a new department?",
    "no-members-in-workgroup": "No work group members yet",
    "no-members-in-workgroup-description": "Work groups let users to exist in more than one team or department",
    "area-unavailable": "'Area - Unavailable'",
    "area": "Area:",
    "no-one-booked-in-area": "No one's booked into this area",
    "departments": "Departments"
  },
  "custom-whereabouts-page": {
    "whereabouts": "Whereabouts",
    "available-in-team-view": "Available in Team View, whereabouts enable your team plan to their working week.",
    "how-it-works": "How it works",
    "custom-whereabouts-requirements": "The following whereabouts are required by the system to function correctly but you can add further custom whereabouts below.",
    "promo-title": "Create and manage custom whereabouts",
    "promo-message": "Add custom Whereabouts to give your teams more options such as Offsite, Training, Illness and get detailed reporting in the reports section.",
    "enable-whereabouts-option": "Enable this whereabouts option",
    "day-notes-title": "Enable day notes",
    "day-notes-description": "Adds a free text field to the whereabouts option",
    "schengen-title": "Activar seguimiento Schengen",
    "schengen-description": "Esta ubicación contará como un día Schengen",
    "description": "Permita a su equipo planificar su semana de trabajo.",
    "default": "Por defecto",
    "create-title": "Crear ubicación personalizada",
    "step-1-name": "1. Nombre de la ubicación",
    "step-2-icon": "2. Elegir un icono",
    "step-3-availability": "3. Mostrar disponibilidad en el calendario de Outlook o Google como:",
    "final-setup": "Configuración final",
    "option-list-title": "Ofrecer a los usuarios una lista de opciones",
    "option-list-description": "Cuando un usuario seleccione esta ubicación, se le pedirá que elija de la lista siguiente",
    "option-list-upsell": "Las listas de opciones están disponibles en los planes Premium y Enterprise.",
    "option-list-upsell-link": "Mejora tu plan",
    "option-list-not-enabled": "Esta función no está habilitada en tu cuenta. Contacta con",
    "option-list-add-option": "Añadir opción",
    "option-list-free-text-title": "Permitir texto libre",
    "option-list-free-text-description": "Los usuarios también pueden escribir su propia respuesta en lugar de elegir de la lista",
    "delete-whereabouts": "Eliminar esta ubicación"
  },
  "dialog": {
    "create-workgroup": "Create a workgroup",
    "add-new-team": "Add a new team",
    "add-people-to-team-message": "Ok lets add some people to this team",
    "max-teams-header-msteams": "You've run out of teams",
    "max-teams-header": "You've reached the maximum limit of teams",
    "max-teams-message-msteams": "You've reached the maximum limit of teams.",
    "max-teams-message": "You've used up your teams allowance, either delete some or upgrade your account.",
    "add-company-to-add-more-teams": "Add a company to add more teams",
    "add-self-to-team": "Add yourself to team",
    "add-self-to-team-warning": "This will update the current team you're in.",
    "selected-number-of-users-to-report-to-a-user": "You have selected {{userCount}} people that report to this person.",
    "week-notes": "Week notes",
    "no-week-notes": "No notes set for the team",
    "week-note-request-not-made": "Request has not been made yet",
    "week-notes-not-in-a-team": "You are not in a team. You can only set a note when you are in a team.",
    "add-note": "Add note",
    "week-note-last-updated": "Updated {{lastUpdated}}",
    "saved-whereabouts-errors-title": "Important: unable to save some of your future desk bookings",
    "saved-whereabouts-errors-content-1": "Your company's office booking policy limits future bookings for {{officeName}} to {{weeksAhead}} weeks ahead.",
    "saved-whereabouts-errors-content-2": "Currently, you can only book {{officeName}} up to the week ending {{weekEnding}}.",
    "saved-whereabouts-errors-content-2-fallback": "Currently, you can cannot book whereabouts that fair in advance.",
    "parking-whereabouts-errors-title": "Parking unavilable on some days",
    "parking-whereabouts-errors-date": "No parking space available on {{date}}",
    "general-whereabouts-errors-title": "",
    "unable-to-book-desks-far-in-advance-title": "Unable to Book Desks too Far in Advance",
    "unable-to-book-desks-far-in-advance-para1": "Your company's office booking policy limits future bookings for the {{officeName}} office to {{bookingWindow}} weeks ahead.",
    "unable-to-book-desks-far-in-advance-para2": "Currently, you can only book the {{officeName}} office up to the week commencing {{weekCommencing}}.",
    "unable-to-book-desks-far-in-advance-days_one": "La política de reservas de oficina de su empresa limita las reservas futuras de la oficina {{officeName}} a {{count}} día de antelación.",
    "unable-to-book-desks-far-in-advance-days_other": "La política de reservas de oficina de su empresa limita las reservas futuras de la oficina {{officeName}} a {{count}} días de antelación.",
    "unable-to-book-desks-far-in-advance-workdays_one": "La política de reservas de oficina de su empresa limita las reservas futuras de la oficina {{officeName}} a {{count}} día laborable de antelación.",
    "unable-to-book-desks-far-in-advance-workdays_other": "La política de reservas de oficina de su empresa limita las reservas futuras de la oficina {{officeName}} a {{count}} días laborables de antelación.",
    "unable-to-book-desks-far-in-advance-up-to": "Actualmente solo puede reservar la oficina {{officeName}} hasta el {{lastDate}}.",
    "unable-to-book-desks-far-in-advance-up-to-opens": "Actualmente solo puede reservar la oficina {{officeName}} hasta el {{lastDate}}. Se abrirán más fechas el {{opensAt}}.",
    "cannot-edit-approved-holiday-title": "Can't Edit Approved Holiday",
    "cannot-edit-approved-holiday-para1": "To cancel a holiday booking:",
    "cannot-edit-approved-holiday-list1": "Go to the Leave Planner",
    "cannot-edit-approved-holiday-list2": "Go to the Holidays Tab",
    "cannot-edit-approved-holiday-list3": "Tap the Edit Pencil on the holiday you wish to cancel",
    "cannot-edit-approved-holiday-list4": "Delete Holiday request",
    "cannot-edit-approved-holiday-para2": "This will cancel the holiday request.",
    "booked": "Booked",
    "unavailable": "Unavailable"
  },
  "approved-holiday-whereabouts-errors": {
    "title": "Can’t Edit Approved Holiday",
    "line1": "To cancel a holiday booking:",
    "line2": "Go to the <strong>Leave Planner</strong>",
    "line3": "Go to the <strong>Holidays Tab</strong>",
    "line4": "Tap the <strong>Edit Pencil</strong> on the holiday you wish to cancel",
    "line5": "<strong>Delete holiday request</strong>",
    "line6": "This will cancel the holiday request."
  },
  "add-multiple-users-dialog": {
    "title": "Add multiple users"
  },
  "usage-dialog": {},
  "side-of-day-dialog": {
    "title": "How Long Do you Require the Desk For?"
  },
  "day-notes-dialog": {
    "add-note": "Add note",
    "recent-notes": "Recent notes"
  },
  "whereabouts-option-picker-dialog": {
    "pick-option": "Elige una opción",
    "or-free-text": "O escribe tu propia respuesta",
    "skip": "Continuar sin elegir"
  },
  "settings-page": {
    "title": "Settings",
    "manage-users": "Gestionar usuarios",
    "manage-users-1": "Edit, manage and add new users",
    "manage-users-2": "Change user permissions and default office",
    "manage-users-3": "Add key roles to users such as firewardens",
    "manage-teams": "Gestionar equipos, grupos de trabajo y departamentos",
    "manage-teams-1": "Edit, manage and add new teams",
    "manage-teams-2": "View team members",
    "teams-tab": "Equipos",
    "workgroups-tab": "Grupos de trabajo",
    "no-workgroups-message": "Users can be added to multiple workgroups to help group users across teams and departments.",
    "departments-tab": "Departamentos",
    "manage-departments": "Gestionar departamentos",
    "manage-departments-1": "Edit, manage and add new departments",
    "manage-departments-2": "View department members",
    "whereabouts": "Custom whereabouts",
    "whereabouts-1": "Choose additional whereabouts locations",
    "whereabouts-2": "Add multiple offsite locations",
    "reports": "Reports, data and audit logs",
    "report-1": "See reports on office usage",
    "report-2": "See reports on whereabouts and holidays",
    "report-3": "Download and export reports to excel",
    "office": "Oficinas y salas de reuniones",
    "office-1": "Crear y gestionar ubicaciones de oficina, planos de planta y escritorios.",
    "office-2": "Configurar salas de reuniones y sincronizar con Outlook.",
    "office-3": "Gestionar aparcamiento y otras áreas reservables.",
    "holiday": "Leave settings",
    "holiday-1": "Turn on leave tracking and set up approvals",
    "holiday-2": "Change leave year start and end",
    "holiday-3": "Add national and company wide leave",
    "meeting-rooms": "Salas de reuniones",
    "meeting-rooms-1": "Create and edit bookable meeting rooms",
    "meeting-rooms-2": "Sync meeting rooms to Outlook Meeting rooms",
    "company": "Company settings",
    "company-1": "Control company wide settings ",
    "company-2": "Allow new users who reside in your company to log in",
    "company-3": "Change icon pack and set up repeat schedules",
    "personal": "Personal preferences",
    "personal-pref-1": "Manage calendar sync (Outlook and Gmail)",
    "personal-pref-2": "Manage favourites offices and desks",
    "personal-pref-3": "Enter car information for parking",
    "billing": "Billing and plan settings",
    "billing-1": "Increase or decrease your subscription",
    "billing-2": "View your invoices and receipts",
    "how-desk-capacities-work": "Enable desk booking if you would like to manage office capacities or split an office into floors and areas. If you'd like to include an interactive floor plan, simply send a reference diagram to <0>hello@team-today.com</0>.",
    "how-desk-capacities-work-title": "How it works",
    "edit-user": {
      "title": "Edit user",
      "email-address": "Email address",
      "member-of-team": "Member of team",
      "member-of-department": "Member of department",
      "member-of-workgroups": "Member of workgroups",
      "not-assigned-to-workgroups": "Not assigned to any workgroups",
      "location-title": "Location",
      "location-message": "Setting a default location makes choosing a desk quicker for colleagues. They can still pick any office to visit.",
      "office-base": "Office base",
      "standard-user": "Standard user",
      "basic-permissions": "Can only set their own whereabouts",
      "department-admin-permissions-1": "Full department management",
      "department-admin-permissions-2": "Is able to view and update all users within the department",
      "department-admin": "Department admin",
      "team-admin": "Team admin",
      "team-admin-permissions-1": "Full team management including adding and removing team members",
      "team-admin-permissions-2": "Can add new users and update users information",
      "team-admin-permissions-3": "Can make other users team admins",
      "office-admin": "Office admin",
      "office-admin-permissions-1": "Full office management of the users designated default office",
      "office-admin-permissions-2": "Can update office whereabouts of other users",
      "office-admin-permissions-3": "Access to office reporting",
      "office-admin-permissions-4": "Can make other users team admins",
      "company-admin": "Company Admin",
      "company-admin-permissions-1": "Full company management including creating and deleting teams",
      "company-admin-permissions-2": "Editing company details",
      "company-admin-permissions-3": "Add or remove users in any team",
      "permissions": "Permissions",
      "holiday-allowance": "Individual holiday allowance for the year",
      "holiday-allowance-message": "This overrides the default Company Leave allowance. This will be reset at the turn of the leave year back to the company default.",
      "users-allowance": "Set the holiday allowance for year",
      "for-year": "days for the year",
      "holiday-allowance-taken-from-users-setting": "The current leave allowance is taken from this User setting",
      "holiday-allowance-taken-from-company-setting": "The current leave allowance is taken from the Company settings",
      "holiday-allowance-not-yet-set": "The current leave allowance has not been set in the Company settings or in this User setting.",
      "additional-responsibilities": "Additional responsibilities",
      "additional-responsibilities-message": "Create Fire wardens and first aiders so you can easily see if there are any booked in to an office.",
      "access-permitted-title": "Access to Team Today",
      "access-permitted-description": "User will still existing in Team Today but they will not be able to log in.",
      "birthday": {
        "title": "Share your birthday",
        "description": "Let others know when your birthday is coming up, this will display on the team view and work planner.",
        "month": "Month",
        "day": "Day"
      },
      "profile-tab": "Perfil",
      "team-tab": "Equipo y grupos",
      "office-tab": "Oficina",
      "access-tab": "Acceso y permisos",
      "leave-tab": "Ausencias",
      "responsibilities-tab": "Responsabilidades",
      "teams-section": "Equipos",
      "groups-section": "Grupos",
      "delete-title": "Eliminar este usuario",
      "delete-description": "Al eliminarlo, este usuario se quita de Team Today y se libera su licencia. Puede restaurarlo desde <0>Usuarios eliminados</0> durante 30 días. Después, el usuario y todos sus datos se eliminan de forma permanente.",
      "delete-alternative": "Para impedir que alguien inicie sesión pero conservar su cuenta y su historial, desactive Acceso a Team Today en <0>Acceso y permisos</0>.",
      "delete-admin-only": "Solo los administradores de la empresa pueden eliminar usuarios."
    }
  },
  "audit-logs-page": {
    "title": "Registros de auditoría",
    "search": "Buscar",
    "search-placeholder": "Buscar por persona o descripción",
    "action": "Acción",
    "source": "Origen",
    "all-actions": "Todas las acciones",
    "all-sources": "Todos los orígenes",
    "showing": "Mostrando {{shown}} de {{total}} entradas",
    "no-results": "Ninguna entrada del registro de auditoría coincide con sus filtros.",
    "load-more": "Cargar más",
    "error": "No se pudieron cargar los registros de auditoría. Inténtelo de nuevo.",
    "category": "Categoría",
    "all-categories": "Todas las categorías",
    "col-date": "Fecha",
    "col-action": "Acción",
    "col-user": "Usuario",
    "col-affected": "Usuario afectado",
    "col-source": "Origen",
    "col-description": "Descripción",
    "categories": {
      "HOLIDAYS": "Vacaciones y ausencias",
      "WHEREABOUTS": "Ubicaciones",
      "USER_MANAGEMENT": "Gestión de usuarios",
      "MEETING_ROOMS": "Salas de reuniones",
      "COMPANY_SETTINGS": "Configuración de la empresa",
      "SECURITY": "Seguridad y claves API",
      "NOTIFICATIONS": "Notificaciones",
      "OFFICE_CHECK_IN": "Check-in de oficina"
    },
    "sources": {
      "WEB": "Web",
      "SCIM": "SCIM",
      "SCHEDULER": "Planificador",
      "PUBLIC_API": "API pública",
      "SYSTEM": "Sistema"
    }
  },
  "manage-users-page": {
    "title": "Gestionar usuarios",
    "search": "Buscar un usuario",
    "showing-users": "Mostrando {{skip}} - {{count}} de {{total}} usuarios",
    "not-logged-in": "No ha iniciado sesión",
    "resend-invite": "Reenviar invitación",
    "account": "Cuenta",
    "user-count": "{{count}} usuarios",
    "free-spaces-count": "{{count}} espacios libres",
    "add-multiple-users": "Añadir múltiples usuarios",
    "assign-to-office": "Asignar a oficina",
    "assign-to-department": "Asignar a departamento",
    "assign-to-team": "Asignar a equipo",
    "manage-teams": "Gestionar equipos",
    "manage-workgroups": "Gestionar grupos de trabajo",
    "export-users": "Exportar usuarios",
    "assign-to-workgroup": "Asignar a grupo de trabajo",
    "select-all": "Seleccionar todo"
  },
  "holiday": {
    "holiday-year": "Año de permisos",
    "days-left": "Días restantes",
    "days-taken-or-booked": "Días tomados o reservados",
    "company-holiday": "Permisos de empresa",
    "holiday-booking": "Reserva de permisos",
    "your-summary": "Resumen",
    "your-bookings": "Tus reservas",
    "users-bookings": "Reservas de {{firstName}}",
    "holiday-booked": "Permiso reservado"
  },
  "company-holiday": {
    "title": "Vacaciones de empresa",
    "description": "Las vacaciones de empresa se añadirán a los calendarios de todos y evitarán reservas en la oficina",
    "number-of-holidays": "Número de vacaciones"
  },
  "unsubscribe-page": {
    "unsubscribed-title": "Dado de baja",
    "unsubscribed-message-1": "Se ha dado de baja de los correos de recordatorio de Team Today.",
    "unsubscribed-message-2": "Puede volver a suscribirse iniciando sesión y visitando el área de configuración.",
    "unsubscribed-failed-title": "Error al darse de baja",
    "unsubscribed-failed-message": "Ha habido un error al darle de baja.",
    "unsubscribed-contact": "Envíenos un correo a <0>hello@team-today.com</0> para ayuda con la cancelación de suscripción."
  },
  "reports-page": {
    "reporting": "Informes",
    "office-usage-title": "Uso de oficina",
    "office-usage-description": "Ver estadísticas y datos sobre el uso de la oficina",
    "wfh-title": "Informes de trabajo desde casa",
    "wfh-description": "Estadísticas y datos sobre trabajo desde casa",
    "whereabouts-title": "Ubicaciones",
    "all-departments": "Todos los departamentos",
    "all-workgroups": "Todos los grupos de trabajo",
    "whereabouts-description": "Estadísticas y datos sobre ubicaciones del grupo",
    "users-whereabouts-title": "Ubicaciones de usuarios",
    "users-whereabouts-description": "Estadísticas y datos sobre ubicaciones de usuarios individuales",
    "unknown-title": "Ubicaciones desconocidas",
    "unknown-description": "Ver usuarios sin ubicación establecida",
    "line-reports-title": "Informes de línea",
    "line-reports-description": "Ver quién reporta a quién",
    "holiday-usage-title": "Uso de vacaciones",
    "holiday-usage-description": "Ver cuántos días han tomado y les quedan a las personas",
    "checkin-title": "Check-in por correo electrónico",
    "checkin-description": "Ver quién confirmó su visita a la oficina desde el correo de check-in",
    "automatic-checkin-title": "Check-in automático de oficina",
    "automatic-checkin-description": "Ver check-ins automáticos por detección de red",
    "automatic-checkin-log-title": "Registro de check-ins",
    "no-shows-title": "No presentados",
    "no-shows-description": "Personas que reservaron en la oficina y no hicieron check-in",
    "desk-utilization-title": "Utilización de escritorios",
    "desk-utilization-description": "Ver cómo se usan los escritorios en sus oficinas",
    "desk-utilization-download-description": "Descargue un CSV que muestra el estado de reserva diario de cada escritorio (1 = día completo, 0,5 = medio día, 0 = sin reservar) para el período seleccionado.",
    "desk-utilization-report-title": "Informe de utilización de escritorios",
    "desk-utilization-office": "Oficina",
    "desk-utilization-no-data": "No se encontraron datos",
    "desk-utilization-no-data-description": "Seleccione una oficina y rango de fechas para ver la utilización de escritorios.",
    "desk-utilization-total-desks": "Total de escritorios",
    "desk-utilization-total-bookings": "Total de reservas",
    "desk-utilization-days-in-range": "Días en el rango",
    "desk-utilization-utilization": "Utilización",
    "desk-utilization-by-floor": "Utilización por planta",
    "desk-utilization-by-office": "Utilización por oficina",
    "desk-utilization-top-desks": "10 escritorios menos utilizados",
    "desk-utilization-top-offices": "10 oficinas menos utilizadas",
    "desk-utilization-company-wide": "Toda la empresa",
    "desk-utilization-floor-breakdown": "Desglose por planta",
    "desk-utilization-floor": "Planta",
    "desk-utilization-desks": "Escritorios",
    "desk-utilization-bookings": "Reservas",
    "desk-utilization-days": "Días",
    "desk-utilization-download-title": "Descargar informe de uso de escritorios",
    "car-park-utilization-title": "Utilización de aparcamiento",
    "car-park-utilization-description": "Ver cómo se usan las plazas de aparcamiento en sus oficinas",
    "audit-logs-title": "Registros de auditoría",
    "audit-logs-description": "Vea quién cambió qué en su empresa",
    "car-park-utilization-report-title": "Informe de utilización de aparcamiento",
    "car-park-utilization-office": "Oficina",
    "car-park-utilization-no-data": "No se encontraron datos",
    "car-park-utilization-no-data-description": "Seleccione una oficina y rango de fechas para ver la utilización del aparcamiento.",
    "car-park-utilization-total-capacity": "Capacidad total",
    "car-park-utilization-total-bookings": "Total de reservas",
    "car-park-utilization-days-in-range": "Días en el rango",
    "car-park-utilization-utilization": "Utilización",
    "car-park-utilization-by-office": "Utilización por oficina",
    "car-park-utilization-company-wide": "Toda la empresa",
    "car-park-utilization-office-breakdown": "Desglose por oficina",
    "car-park-utilization-capacity": "Capacidad",
    "car-park-utilization-bookings": "Reservas",
    "car-park-utilization-days": "Días",
    "car-park-utilization-daily-breakdown": "Desglose diario",
    "car-park-utilization-daily-utilization": "Utilización diaria",
    "car-park-utilization-date": "Fecha",
    "car-park-utilization-bottom-spaces": "10 plazas menos utilizadas",
    "user-report": "Informe de usuario",
    "department-report": "Informe de departamentos",
    "user-breakdown-title": "Informe de usuario",
    "user-breakdown-description": "Resumen de las ubicaciones de un usuario",
    "user-breakdown-select-user-title": "Para continuar",
    "user-breakdown-select-user-description": "Busque un usuario para ver un resumen de sus ubicaciones durante un período de tiempo.",
    "fire-booked-in": "Vigilantes de incendios reservados",
    "no-fire-booked-in": "Sin vigilantes de incendios en la oficina",
    "first-booked-in": "Socorristas reservados",
    "no-first-booked-in": "Sin socorristas en la oficina",
    "weeks-office-usage": "Uso de oficina esta semana",
    "updated-hourly": "Actualizado cada hora",
    "office-usage-report": "Informe de oficina",
    "download-office-report": "Descargar informe de oficina",
    "download-report": "Descargar un informe",
    "choose-an-office": "Elegir una oficina",
    "no-data-found": "No se encontraron datos para esa selección",
    "select-office-from-past-two-years": "Por favor seleccione una oficina y una fecha pasada dentro de los últimos 2 años.",
    "create-a-report": "Crear un informe",
    "office-usage-confirmation": "Uso de oficina vs. confirmación",
    "typical-office-usage": "Uso típico de oficina",
    "download-holiday-summary": "Descargar informe de vacaciones",
    "download-absence-summary": "Descargar informe de ausencias",
    "edit-holiday-allowance": "Editar asignación de vacaciones",
    "office-usage": {
      "choose-office": "Elegir una oficina",
      "choose-group": "Elegir equipo, grupo o depto.",
      "choose-floor": "Elegir una planta",
      "custom": "Introducir rango de fechas personalizado",
      "exit-custom": "Salir de rango personalizado",
      "download-btn": "Descargar informe de planta",
      "download-desk-usage-btn": "Descargar informe de uso de escritorios",
      "capacity": "{{capacity}}% Capacidad",
      "occupancy": "Ocupación de planta",
      "deskUsage": "Uso de escritorios",
      "top10Desks": "10 escritorios más usados",
      "bottom10Desks": "10 escritorios menos usados"
    },
    "unknown-whereabouts": {
      "title": "Ubicación desconocida",
      "note": "Nota",
      "all-users-have-whereabouts-set": "Todos los usuarios de su selección tienen su ubicación establecida.",
      "reminder-last-sent": "último recordatorio enviado hace {{days}} días"
    },
    "whereabouts-report": {
      "title": "Informe de ubicaciones",
      "no-date": "No se encontraron datos para esa selección",
      "select-a-date": "Por favor seleccione una fecha dentro de los últimos 2 años.",
      "high-level-report": "Informe general",
      "detailed-report": "Informe detallado"
    },
    "holidays-report": {
      "days-used": "Días usados",
      "allowance": "Asignación",
      "team-name": "Nombre del equipo",
      "user": "Usuario",
      "percentage": "%",
      "holiday-year": "Año de permisos: {{year}}",
      "high-level-report": "Informe general .xls",
      "detailed-report": "Informe detallado .xls",
      "report": "Descargar informe",
      "office": "En la oficina (Total)"
    },
    "key-responsib": {
      "title": "Incendios y seguridad",
      "description": "informe y datos",
      "nothing-selected-title": "Nada que mostrar",
      "nothing-selected": "Por favor seleccione una oficina para ver los roles asignados",
      "one-fire-warden": "Un vigilante de incendios por cada",
      "one-first-aider": "Un socorrista por cada",
      "staff": "empleados",
      "fire-warden": "Vigilante de incendios",
      "first-aider": "Socorrista",
      "office-capacity": "Capacidad de la oficina: {{officeCapacity}}",
      "people-in-office": "Personas en la oficina: {{peopleInOffice}}",
      "key-role-in-office": "Rol clave en la oficina: {{keyRoleInOffice}}",
      "loading": "Obteniendo datos, esto puede tardar un minuto"
    }
  },
  "holidays": {
    "company-holidays-applies-to": "Elegir oficinas a las que aplicar esto:",
    "edit-holiday-title": "Editar permiso",
    "add-holiday-title": "Añadir permiso",
    "holidays": "Mis permisos",
    "holidays-disabled": "La gestión de vacaciones no está actualmente activada",
    "holidays-disable-how-to-enable": "Para activar la gestión de vacaciones incluyendo aprobaciones, simplemente active en el área de configuración.",
    "holiday-duration": "{{duration}} días",
    "add-new-leave": "Añadir nuevo permiso",
    "add-leave": "Añadir permiso",
    "for-me": "Para mí",
    "for-another": "Para otro miembro del equipo",
    "holiday-year-span": "Año de permisos {{from}} - {{to}}",
    "booked": "Permiso reservado",
    "add-more-leave": "Añadir más permisos",
    "leave-reporting": "Informes de permisos",
    "days-booked": "Días reservados",
    "days-left": "Días restantes",
    "view-holidays": "Ver vacaciones",
    "allowance": "Asignación: {{number}} días",
    "carried-over": "Traspasado: {{number}} días",
    "insufficient-access-title": "Acceso de administrador requerido",
    "insufficient-access-description": "Para acceder a datos e informes, contacte con su gerente o administrador para solicitar los permisos necesarios.",
    "holiday-tracking-disabled-title": "Informes de permisos inactivos",
    "holiday-tracking-disabled-description": "Puede activar los informes de permisos para gerentes en el área de configuración principal.",
    "leave-planner-disabled-title": "Planificador de permisos inactivo",
    "leave-planner-disabled-description": "Puede activar el seguimiento de permisos en el área de configuración principal."
  },
  "upgrade": "Mejorar plan",
  "change-pricing-plan": "Cambiar tu plan de precios",
  "get-in-touch": "Contactar",
  "company": "Empresa",
  "help": "Ayuda",
  "faqs": "Preguntas frecuentes",
  "copyright": "Copyright © 2026 Team Today. Todos los derechos reservados.",
  "create-new-team": "¿Crear un nuevo equipo?",
  "user-view": "Vista de usuario",
  "User": "Usuario",
  "Email": "Correo electrónico",
  "Team name": "Nombre del equipo",
  "Permissions": "Permisos",
  "tag-manager": "Gestor de grupos de trabajo",
  "Back": "Atrás",
  "back-to-company-view": "Volver a vista de empresa",
  "users": "usuarios",
  "team members": "miembros del equipo",
  "members": "Miembros",
  "Add a team member": "Añadir un miembro del equipo",
  "Invite a user": "Invitar a un usuario",
  "Add existing user": "Añadir usuario existente",
  "Select a team": "Seleccionar un equipo",
  "Search results": "Resultados de búsqueda",
  "days": "días",
  "choose-office-to-view": "Elegir una oficina para ver",
  "create-an-office": "Crear una oficina",
  "create-an-office-description": "Establezca un límite en el número de escritorios disponibles para que los compañeros sepan cuándo ir a la oficina.",
  "office-space-bookings": "Reservas de espacio de oficina",
  "office-space-no-bookings": "Sin reservas",
  "open-office": "Oficina abierta",
  "select-team-to-add-user-to": "Seleccionar equipo al que añadir",
  "team-admins-limitation": "Los administradores de equipo solo pueden mover usuarios a su propio equipo",
  "search-for-existing-user": "Buscar un usuario existente",
  "tag-view": "Vista de etiquetas",
  "Select...": "Seleccionar...",
  "did-you-know": "¿Sabías que?",
  "desk-reservation": "Reserva de escritorio",
  "desk": "Escritorio",
  "added-to-favourites": "Añadido a tus favoritos",
  "add-to-your-favourites": "Añadir a tus favoritos",
  "favouring-an-office-tip": "Marcar una oficina como favorita hace más rápido seleccionarla al establecer tu ubicación para la semana.",
  "back-to-whereabouts": "Volver a ubicaciones",
  "404-error": "Lo sentimos, 404. No encontrado",
  "admin-access-required": "Acceso de administrador requerido",
  "insufficient-rights": "Derechos de acceso insuficientes",
  "onboarding": {
    "add-user": {
      "title": "Añadir un miembro del equipo",
      "message": "Añade hasta 10 personas a este equipo"
    },
    "create-an-office": "Crear una oficina",
    "create-team": "Vamos a crear tu primer equipo para tu empresa...",
    "create-team-description": "Puedes crear tantos equipos como quieras más tarde",
    "welcome-for-company": "Bienvenido a la cuenta de Team Today para",
    "welcome": "Bienvenido a Team Today",
    "welcome-message": "Planifica tu ubicación para la semana laboral, reserva escritorios, gestiona el espacio de oficina y sincronízalo todo con tus calendarios de trabajo.",
    "welcome-to-existing-company": "Empieza simplemente estableciendo tu ubicación para la próxima semana. Esto le permitirá al resto de tu equipo conocer tus planes... es así de simple.",
    "choose-features": "Elige tus funciones",
    "choose-features-description": "Puedes tener tantas o tan pocas como desees. La configuración se puede cambiar en cualquier momento en el futuro.",
    "whereabouts-feature": "Ubicaciones",
    "whereabouts-feature-description": "Una interfaz simple que permite a todos saber dónde está cada uno cada semana.",
    "deskbooking-feature": "Reserva de escritorios y aparcamiento",
    "deskbooking-feature-description": "Controla el espacio de oficina y ve cuántos escritorios están disponibles. Incluso reserva plaza de aparcamiento.",
    "holiday-management-feature": "Gestión de vacaciones",
    "holiday-management-feature-description": "Añade gerentes de línea y autoriza vacaciones a través de Team Today.",
    "office-created-title": "Oficina creada",
    "office-created-message": "Puedes visitar configuración más tarde para crear múltiples oficinas, plantas, áreas y añadir un plano interactivo para que los compañeros reserven.",
    "team-required": "equipo requerido",
    "create-office-reasoning": "Puedes crear múltiples oficinas para que los miembros del equipo las visiten.",
    "holiday-management": "Gestión de vacaciones",
    "holiday-management-description": "Permite a los miembros del equipo llevar un registro de los días restantes y compartirlo con el equipo.",
    "holiday-management-default-number": "Número de vacaciones por defecto",
    "holiday-management-tip": "Puedes establecer asignaciones individuales de vacaciones y establecer una fecha de renovación en configuración",
    "custom-whereabouts-title": "Crea ubicaciones personalizadas y lugares de trabajo fácilmente",
    "custom-whereabouts-description": "Visita el área de configuración/gestión en Team Today para crear ubicaciones personalizadas como obra, formación o visita al cliente y sincronizarlas automáticamente con tus calendarios de correo.",
    "icons-title": "Elige tu estilo de iconos",
    "icons-description": "Elige el estilo que mejor se adapte a tu empresa",
    "icons-detailed": "Iconos detallados",
    "icons-simple": "Iconos simples",
    "onboarding-complete": "Todo configurado...",
    "onboarding-complete-description": "No olvides que puedes descargar la aplicación Team Today desde la tienda de Microsoft Teams e iniciar sesión.",
    "add-to-ms-teams": "Añadir a Microsoft Teams",
    "required": "REQUERIDO"
  },
  "dialog-headers": {
    "sync-to-outlook": "Para la mejor experiencia, sincronice Team Today con su calendario de Outlook",
    "cannot-be-deleted": "Eso no se puede eliminar",
    "are-you-sure": "¿Está seguro?",
    "update-desk": "Actualizar escritorio",
    "edit-tags": "Editar grupos de trabajo",
    "add-group-member": "Añadir un miembro del grupo",
    "manage-favourites": "Gestionar favoritos",
    "filter-selection": "Filtrar selección",
    "whereabouts-have-been-edited": "Sus ubicaciones han sido editadas",
    "team-created": "Equipo creado",
    "choose-area": "Elegir un área",
    "choose-floor": "Elegir una planta",
    "choose-office": "Elegir una oficina",
    "add-custom-whereabouts": "Añadir ubicación personalizada",
    "company-created": "Empresa creada",
    "payment-failed": "Pago fallido",
    "payment-successful": "Pago exitoso",
    "select-line-reports": "Seleccionar informes de línea"
  },
  "payments": {
    "users-available-message": "Puede añadir {{remainingUsers}} compañeros más a esta cuenta.",
    "upgrade-account-in-settings": "Mejore su cuenta en configuración",
    "with-as-many-users": "Con una cuenta de pago puede añadir tantos usuarios como desee.",
    "how-many-users-you-need": "¿Cuántos usuarios necesita?",
    "manage-total-users": "Gestionar el total de usuarios",
    "payment-method": "Método de pago",
    "card-payment": "Pago con tarjeta",
    "bank-transfer": "Transferencia bancaria",
    "bank-transfer-contact": "Para gestionar su plan mediante transferencia bancaria, contacte con <0>hello@team-today.com</0> con los datos de su empresa",
    "bank-transfer-annual-only": "Solo planes anuales",
    "bank-transfer-currencies": "Para transferencias bancarias solo podemos aceptar GBP y euros",
    "bank-transfer-po": "Aceptamos órdenes de compra",
    "how-often-you-pay": "Frecuencia de pago",
    "currency": "Moneda",
    "first-10-users": "Primeros 10 usuarios",
    "FREE": "GRATIS",
    "total-paid-users": "Total de usuarios de pago",
    "monthly-amount": "Importe mensual a pagar",
    "year-amount": "Importe anual a pagar",
    "looking-to-cancel": "¿Desea cancelar?",
    "looking-to-cancel-message": "Nos encantaría que se quedara pero puede cancelar su suscripción en cualquier momento enviando un correo a <0>hello@team-today.com</0>",
    "free-trial-ends": "La prueba gratuita termina",
    "view-payment-plan": "Ver su plan de pago",
    "choose-plan": "Elija su plan",
    "standard": "Estándar",
    "free-plan": "Plan gratuito",
    "professional-plan": "Plan Profesional",
    "premium-plan": "Plan Premium",
    "enterprise-plan": "Plan Enterprise",
    "professional": "Profesional",
    "premium": "Premium",
    "enterprise": "Enterprise",
    "professional-features": "Hasta 6 ubicaciones personalizadas",
    "premium-features": "Reserva de visitantes y hasta 32 ubicaciones personalizadas",
    "enterprise-features": "Gestor de cuenta dedicado y soporte de incorporación",
    "your-plan": "Gestionar su plan",
    "manage-subscription": "Actualizar suscripción",
    "manage-subscription-title": "Su suscripción",
    "nav-your-plan": "Su plan",
    "nav-invoices": "Facturas",
    "current-plan": "Plan actual",
    "looking-to-upgrade": "¿Quieres mejorar tu plan?",
    "contact-us": "Contáctanos",
    "upgrade-plan": "Mejorar plan",
    "upgrade-contact-title": "Mejora o actualiza tu suscripción",
    "manage-plan-title": "Gestiona tu plan",
    "manage-plan-body": "Para ajustar tu número de licencias o cambiar tu plan de suscripción, contáctanos en <0>hello@team-today.com</0>. Actualizaremos los datos de tu cuenta y gestionaremos los ajustes de facturación prorrateados por ti.",
    "enterprise-contact-body": "Para pasar a nuestro plan Enterprise, ponte en contacto en <0>hello@team-today.com</0> para hablar con un gestor de cuentas.",
    "your-payment-plan": "Su plan de pago",
    "plan-pill": "Plan {{plan}}",
    "monthly-plan": "Plan mensual",
    "annual-plan": "Plan anual",
    "total-licences": "Licencias totales: {{licences}}",
    "plan-cost-summary-monthly": "{{cost}} / mes - Facturado mensualmente",
    "plan-cost-summary-yearly": "{{cost}} / año - Facturado anualmente",
    "next-renewal": "Próxima renovación: {{date}}",
    "custom-whereabouts-count": "{{number}} x Ubicaciones personalizadas",
    "unlock-more-premium": "desbloquee más con Premium",
    "meeting-rooms-count": "{{number}} x Salas de reuniones",
    "professional-custom-whereabouts": "32 x Ubicaciones personalizadas",
    "professional-meeting-rooms": "24 x Salas de reuniones",
    "advanced-reporting": "Informes avanzados",
    "priority-support": "Soporte prioritario",
    "interactive-floor-plans": "Planos interactivos",
    "car-parking": "Aparcamiento",
    "free-trial": "Prueba gratuita",
    "change-plan-hint": "El cambio de plan surte efecto de inmediato; su próxima factura se prorrateará.",
    "confirm-plan-change": "¿Cambiar su plan de suscripción ahora? Su próxima factura se prorrateará.",
    "confirm-plan-change-title": "Cambiar de plan",
    "confirm-plan-change-button": "Confirmar cambio",
    "plan-changed": "Su plan se ha actualizado",
    "plan-change-failed": "No pudimos cambiar su plan, contacte con hello@team-today.com",
    "downgrade-contact-support": "Para bajar de plan, contacte con <0>support@team-today.com</0>",
    "manage-seats": "Gestionar el total de licencias",
    "seats-in-use": "{{used}} de {{total}} plazas de usuario de pago en uso",
    "licences-in-use": "{{used}} de {{total}} licencias actualmente en uso",
    "price-per-licence": "Precio por licencia",
    "licences": "Licencias",
    "total": "Total",
    "period-month": "mes",
    "period-year": "año",
    "update-seats": "Actualizar plazas",
    "seats-change-hint": "El cambio de plazas pagadas surte efecto de inmediato; su próxima factura se prorrateará.",
    "seats-updated": "Sus plazas pagadas se han actualizado",
    "seats-update-failed": "No pudimos actualizar sus plazas pagadas, contacte con hello@team-today.com",
    "update-licenses": "Actualizar suscripción",
    "licenses-updated": "Sus licencias se han actualizado",
    "licenses-update-failed": "No pudimos actualizar sus licencias, contacte con hello@team-today.com",
    "past-invoices": "Facturas anteriores",
    "view-invoice": "Ver",
    "no-invoices": "Aún no hay facturas anteriores",
    "invoices-load-failed": "No pudimos cargar sus facturas en este momento",
    "invoice-date": "Fecha",
    "invoice-amount": "Importe",
    "invoice-status": "Estado"
  },
  "team": {
    "empty-team-title": "No hay miembros en este equipo",
    "empty-team-description": "No te preocupes, puedes añadir personas",
    "team-member-invited": "Miembro del equipo invitado",
    "add-more-users-message": "Puedes añadir más compañeros ahora o más tarde a través de la aplicación",
    "add-more-users-message-with-limit": "Puedes añadir <0>{remainingUsers} más</0> compañeros a tu <1>cuenta gratuita</1>",
    "remaining-users": "{{remainingUsers}} más",
    "free-account": "cuenta gratuita",
    "paid-account-upsell": "Con una cuenta de pago puedes añadir tantos usuarios como desees. Configura una prueba GRATUITA de 30 días enviando un correo a: hello@team-today.com.",
    "upgrade-link": "O mejora tu cuenta en configuración",
    "restricted-team-title": "Este equipo es privado",
    "restricted-team-description": "Para acceder a este equipo pide a un administrador que te añada."
  },
  "whereabouts": {
    "select-floor": "Seleccionar una planta",
    "select-floor-description": "Seleccione una planta para ver la oficina y reservar su escritorio.",
    "looking-after-multiple-teams": "¿Gestionando múltiples equipos?",
    "create-company-view": "Crea una vista de empresa para ver todos tus equipos en un solo lugar",
    "custom-whereabouts": "Ubicaciones personalizadas",
    "add-custom-whereabouts": "Añadir ubicación personalizada",
    "whereabouts-set-for-this-week": "Ubicaciones establecidas para esta semana",
    "all-done": "Todo listo",
    "available-areas": "Áreas disponibles",
    "available-desks": "Elegir escritorio del desplegable",
    "seats-available": "{{remaining}} asientos disponibles",
    "add-favourite": "Añadir favorito",
    "favouriting-suggestion-title": "¿Cambias de oficina regularmente?",
    "favouriting-suggestion-description": "Marcar una oficina como favorita hace más rápido seleccionarla al establecer tu ubicación para la semana.",
    "no-offices": "¡Sin oficinas!",
    "no-offices-description": "Añade una o más oficinas en configuración para aprovechar al máximo esta función.",
    "add-office-button": "Añadir oficina",
    "num-of-group-members": "{{count}} miembros del grupo",
    "desks-available": "Escritorios disponibles",
    "parking-available": "Aparcamiento disponible",
    "no-available": "Sin aparcamiento",
    "require-parking-space": "Necesita plaza de aparcamiento",
    "require-weekly-schedule": "Repetir horario",
    "parking": "Aparcamiento",
    "car-park-bookings": "Reservas de aparcamiento",
    "car-park-capacity-and-usage": "{{spaces}} Plazas - {{bookings}} Reservas",
    "select-on-floor-plan": "Elegir un escritorio en el plano",
    "repeat-schedule": {
      "title": "Repetir horario semanal",
      "alternate-weeks": "Alternas",
      "repeat-schedule-for": "Repetir cada semana durante",
      "weeks": "semanas",
      "confirm-schedule": "Confirmar horario",
      "cancel": "Cancelar",
      "close": "Cerrar",
      "updating": "Actualizando sus semanas. Esto puede tardar un minuto.",
      "cannot-be-done-setting-not-set": "Esta función no se puede usar. Pida a un administrador de empresa que vaya a Configuración de empresa para configurar el número de semanas que puede establecer."
    }
  },
  "office-checkin-page": {
    "title": "Gracias",
    "confirmed": "Eso ha sido confirmado.",
    "login-message": "Ahora puede iniciar sesión para ver su ubicación o la de sus compañeros."
  },
  "delete-team-dialog": {
    "title": "Eliminar equipo",
    "description": "¿Está seguro de que desea eliminar este equipo?",
    "warning-message": "Los usuarios podrán seguir iniciando sesión pero no estarán asignados a un equipo"
  },
  "sync-to-outlook-dialog": {
    "yes": "Sí, sincronizar con Outlook",
    "no": "Quizás más tarde",
    "message": "Siempre puede configurar esto más tarde visitando configuración y editando sus preferencias personales."
  },
  "whereabouts-changed-dialog": {
    "accept-message": "Para aceptar los cambios simplemente pulse el botón aceptar cambios y sincronícelos con su calendario.",
    "accept-with-no-outlook-sync-1": "Para aceptar los cambios simplemente pulse el botón aceptar cambios.",
    "accept-with-no-outlook-sync-2": "Puede sincronizarlos con su cuenta de Microsoft 365 o Google activando la opción en Configuración.",
    "accept-and-sync": "Aceptar cambios y sincronizar con calendario",
    "accept": "Aceptar cambios"
  },
  "delete-desk-dialog": {
    "message": "Eliminar oficina eliminará lo siguiente:",
    "a-desk": "1 escritorio",
    "bookings": "{{count}} reserva(s) de ubicación",
    "cannot-be-deleted": "Ese escritorio pertenece a una planta que tiene un plano configurado, por favor contáctenos en <a href=\"mailto:support@team-today.com\">support@team-today.com</a> si desea eliminarlo."
  },
  "delete-office-dialog": {
    "message": "Eliminar oficina eliminará lo siguiente:",
    "office": "{{count}} oficina(s)",
    "floor": "{{count}} planta(s)",
    "area": "{{count}} área(s)",
    "desk": "{{count}} escritorio(s)",
    "favourites": "{{count}} favorito(s)",
    "cannot-be-deleted-message": "Esa oficina contiene una planta, por favor contáctenos en <0 href=\"mailto:support@team-today.com\">support@team-today.com</0> si desea eliminarla."
  },
  "delete-user-dialog": {
    "description": "¿Está seguro de que desea eliminar este usuario?",
    "title": "Advertencia"
  },
  "calendar": {
    "mon": "L",
    "tue": "M",
    "wed": "X",
    "thur": "J",
    "fri": "V",
    "sat": "S",
    "sun": "D",
    "choose-week": "Elegir una semana para ver"
  },
  "ms-ad-sync": {
    "read-all-message-1": "Esta función requiere permisos diferentes, solo se usará en su ordenador y no se enviará información sensible a nuestros servidores.",
    "read-all-message-2": "Haga clic aquí para solicitar permisos a Microsoft",
    "message-1": "A continuación se muestra una lista de todos los usuarios en su cuenta de Microsoft pero no en Team Today.",
    "message-2": "Puede desplazarse rápidamente e invitar a las personas que desea que tengan acceso a Team Today.",
    "message-3": "Después de invitarlos tendrá que añadirlos a un equipo o pueden añadirse ellos mismos a un equipo cuando se registren."
  },
  "room-finder": {
    "title": "Buscador de salas",
    "no-selection": "No se han añadido salas de reuniones",
    "no-meeting-rooms-in-office": "No hay salas de reuniones en esta oficina",
    "no-meeting-bookings": "No tiene reservas de salas de reuniones para mostrar.",
    "navigation": {
      "room-finder": "Buscador de salas",
      "bookings": "Mis reservas",
      "open-search-panel": "Mostrar filtros",
      "filters": "Filtros"
    },
    "number-of-people": {
      "title": "Número de personas",
      "any": "Cualquiera",
      "1to2": "1 - 2",
      "3to5": "3 - 5",
      "6to8": "6 - 8",
      "8orMore": "8+"
    },
    "facilities": {
      "title": "Instalaciones",
      "tv": "TV",
      "conference-call": "Conferencia telefónica",
      "whiteboard": "Pizarra",
      "charge-points": "Puntos de carga"
    },
    "floor-filter": {
      "title": "Planta",
      "all-floors": "Todas las plantas"
    }
  },
  "room-booking-dialog": {
    "add-to-calendar": "Añadir al calendario",
    "is-teams-meeting": "Reunión de Teams",
    "outlook-booked-meeting": "Esta reunión fue reservada a través de Outlook, puede actualizarla aquí pero los cambios pueden no reflejarse en Outlook.",
    "notes": "Notas (establecidas en Team Today)",
    "edit-booking-title": "Editar reserva",
    "title": "Reservar sala de reuniones",
    "meeting-title": "Introducir título de la reunión",
    "confirm-booking": "Confirmar reserva",
    "update-booking": "Actualizar reserva",
    "cancel-booking": "Cancelar reserva",
    "cancel-series": "Cancelar serie",
    "apply-to-series": "Aplicar los cambios a todas las reuniones futuras de esta serie",
    "save-changes": "Guardar cambios",
    "no-booker-name": "Reserva de Outlook",
    "cannot-book-outlook-room": "No puede reservar esta sala de reuniones",
    "cannot-book-outlook-room-description": "Primero asegúrese de que su sincronización de calendario esté activa para que podamos reservar la sala en todo el sistema.",
    "booked-in-outlook-title": "Esta reunión fue reservada a través de Outlook.",
    "booked-in-outlook-description": "Para hacer cambios en esta reserva, vaya a su calendario de Outlook.",
    "outlook-link": "Enlace de Outlook",
    "can-not-update-outlook-meeting": "No se pueden actualizar los detalles de la reunión de Outlook",
    "recurrence": "Recurrencia",
    "no-recurrence": "Sin recurrencia",
    "daily": "Diario",
    "weekly": "Semanal",
    "monthly": "Mensual",
    "yearly": "Anual",
    "for": "Durante",
    "frequency-day": "día(s)",
    "frequency-week": "semana(s)",
    "frequency-month": "mes(es)",
    "frequency-year": "año(s)",
    "recurrence-summary": "Ocurre {{frequency}} el {{dayName}}, termina el {{endDate}}.",
    "recurrence-summary-single": "Ocurre {{frequency}} el {{dayName}}.",
    "recurrence-summary-monthly": "Ocurre mensualmente el {{dayOfMonth}}, termina el {{endDate}}.",
    "recurrence-summary-monthly-single": "Ocurre mensualmente el {{dayOfMonth}}.",
    "recurrence-summary-daily": "Ocurre cada día laborable (lun-vie), termina el {{endDate}}.",
    "recurrence-summary-daily-single": "Ocurre cada día laborable (lun-vie).",
    "or-until": "Hasta"
  },
  "delete-meeting-room-dialog": {
    "delete-meeting-room": "Eliminar sala de reuniones",
    "confirm-delete-meeting-room": "Sí, eliminar esta sala de reuniones",
    "capacity": "Aprox. {{capacity}} personas",
    "cancel": "No, mantener esta sala de reuniones"
  },
  "reset-desks-dialog": {
    "reset-desks": "Restablecer escritorios seleccionados",
    "reset-all-desks": "Va a restablecer la asignación de {{count}} escritorios",
    "cancel": "Cancelar"
  },
  "link-group-to-office-dialog": {
    "title": "Vincular equipo o grupo de trabajo a oficina",
    "office-label": "Seleccionar oficinas",
    "link-button": "Vincular oficinas",
    "clear-button": "Eliminar oficinas de grupos"
  },
  "new-user-onboarding-dialog": {
    "title": "Bienvenido a Team Today",
    "done": "Hecho",
    "intro": "Puede configurarse rápidamente completando estos dos pasos.",
    "next": "Siguiente",
    "office-label": "Seleccionar oficinas"
  },
  "manage-desks-sidebar": {
    "edit-view": "Vista de edición",
    "desk-allocation": "Asignación de escritorios",
    "edit-desk": "Editar escritorio",
    "desk-editor": "Editor de escritorios",
    "area-name": "Nombre del área",
    "changed-desks-count": "{{count}} escritorio modificado",
    "changed-desks-count_plural": "{{count}} escritorios modificados",
    "save-desk-changes": "Guardar cambios de escritorios",
    "total-desks": "{{total}} escritorios en total",
    "selected-desks": "{{selected}} escritorios seleccionados",
    "select-all-desks": "Seleccionar todos los escritorios",
    "assign-to-indi": "Asignar a individual",
    "assign-to-team": "Asignar a equipo",
    "assign-to-workgroup": "Asignar a grupo de trabajo",
    "reset-desks": "Restablecer escritorios seleccionados",
    "assign-desks-to-team": "Asignar escritorios a equipo",
    "assign-desks-to-individual": "Asignar escritorios a individual",
    "assign-desks-to-workgroup": "Asignar escritorios a grupo de trabajo",
    "active": "Activo"
  },
  "edit-team": {
    "select-office-description": "Seleccione oficinas asociadas a este equipo",
    "select-departments-description": "Seleccione departamentos asociados a este equipo",
    "title": "Editar equipo",
    "team-name": "Nombre del equipo"
  },
  "team-and-group-radio-button-list": {
    "filter-desks": "Filtrar escritorios por equipos y grupos de trabajo",
    "show-all": "Mostrar todo"
  },
  "manage-tag-dialog": {
    "delete": "Eliminar grupo de trabajo",
    "update": "Actualizar grupo de trabajo",
    "group-summary": "Hay {{count}} usuarios en este grupo de trabajo",
    "edit-title": "Editar un grupo de trabajo",
    "create-title": "Crear un grupo de trabajo"
  },
  "manage": {
    "add-new-user": {
      "title": "Añadir un miembro del equipo",
      "subtitle": "Invitar hasta {{count}} compañeros a esta cuenta",
      "invite-new-user": "Invitar a un nuevo usuario",
      "add-existing-user": "Añadir un usuario existente",
      "required": "Requerido",
      "account": "Cuenta",
      "free": "Cuenta gratuita",
      "premium": "Cuenta premium",
      "trial": "Cuenta de prueba",
      "enterprise": "Cuenta empresarial",
      "total": "Total de licencias",
      "current": "Usuarios actuales",
      "remaining": "Espacios restantes",
      "team-member-added": "Miembro del equipo añadido",
      "user-already-in-account": "Esta cuenta ya existe.\nVe a Configuración > <0>Gestionar usuarios</0> para asignarla al equipo correcto.",
      "user-deleted": "La cuenta ya existe.\nEste usuario fue eliminado anteriormente. Puedes restaurar su acceso en Configuración > Gestionar usuarios > <0>Usuarios eliminados</0>.",
      "paid-account-promote": "Con una cuenta de pago puede añadir tantos usuarios como desee. Configure una prueba GRATUITA de 30 días enviando un correo a: hello@team-Today.com",
      "upgrade": "O mejore su cuenta en configuración"
    }
  },
  "header": {
    "meeting-rooms": "Salas de reuniones",
    "leave-planner": "Planificador de permisos",
    "reports": "Informes",
    "view-my-bookings": "Ver mis reservas",
    "hospitality": "Hospitalidad"
  },
  "floor-plan-editor": {
    "open-editor": "Editar plano (Beta)",
    "add-desk": "Añadir escritorio",
    "add-area": "Añadir zona",
    "save": "Guardar",
    "selected": "{{label}} seleccionado",
    "rename-desk": "Renombrar escritorio",
    "clone-desk": "Clonar escritorio",
    "keyboard-hint": "WASD para mover, Q y E para rotar, C para clonar",
    "delete-desk": "Eliminar escritorio",
    "desk-portrait": "Escritorio V ({{width}}, {{height}})",
    "desk-landscape": "Escritorio H ({{width}}, {{height}})",
    "corner-desk-portrait": "Escritorio esquinero V ({{width}}, {{height}})",
    "corner-desk-landscape": "Escritorio esquinero H ({{width}}, {{height}})",
    "rotate-left": "Girar {{degrees}}° a la izquierda",
    "rotate-right": "Girar {{degrees}}° a la derecha",
    "new-area": "Nueva zona",
    "no-desks-warning": "Primero debes añadir al menos un escritorio desde el panel de configuración",
    "unsaved-changes": "Tienes cambios sin guardar en el plano. ¿Seguro que quieres salir?",
    "save-success": "Cambios del plano guardados",
    "save-failed": "No se pudieron guardar los cambios del plano",
    "area-create-failed": "No se pudo crear la zona",
    "no-floor-plan": "Esta oficina no tiene un plano interactivo."
  },
  "office-map": {
    "select-office": "Seleccionar una oficina"
  },
  "desk-booking": {
    "confirm-booking": "Confirmar reserva",
    "edit-parking": "Editar aparcamiento",
    "no-space-selected": "Sin espacio seleccionado"
  },
  "car-parking": {
    "label": "Etiqueta",
    "yaxis": "Eje Y",
    "width": "Ancho",
    "height": "Alto",
    "rotation": "Rotación",
    "xaxis": "Eje X",
    "edit-space-title": "Editar plaza de aparcamiento",
    "cancel-booking": "Cancelar reserva",
    "am-cancel-booking": "Cancelar mañana",
    "pm-cancel-booking": "Cancelar tarde",
    "are-you-sure-delete": "¿Está seguro de que desea eliminar esta plaza de aparcamiento?"
  },
  "visitor-booking": {
    "daily-visitors": "Visitantes de oficina",
    "filter": "Filtrar visitantes",
    "visitors-in-today": "{{count}} visitantes hoy",
    "manage-visitors": "Gestionar visitantes",
    "visitor-office-title": "Visitantes - Oficina {{officeName}}",
    "add-visitor": "Añadir un visitante",
    "edit-visitor": "Editar un visitante",
    "cancel": "Eliminar visitante",
    "visitor-name": "Nombre del visitante",
    "company-name": "Nombre de la empresa",
    "due-in": "Esperado a las",
    "meeting-with": "Reunión con",
    "due-today": "Esperado hoy",
    "signed-in": "Registrado",
    "signed-out": "Salido",
    "no-visitors-today": "Sin visitantes hoy",
    "repeat-booking": "Repetir reserva",
    "cancel-desk": "Cancelar escritorio",
    "book-desk": "Reservar escritorio",
    "sign-in": "Registrarse",
    "sign-out": "Salir",
    "meeting-room-label": "Sala de reuniones: {{room}}",
    "meeting-room-label-with-time": "Sala de reuniones: {{room}}, de {{from}} a {{to}}"
  },
  "department-dialog": {
    "title": "Editar departamento",
    "name": "Nombre",
    "users": "Número de usuarios en el departamento"
  },
  "allowance": {
    "expiry-report": "Informe de vencimiento de vacaciones",
    "go-to-reporting": "Ir a informes",
    "carry-over": "Traspaso",
    "go-to-rollover-management": "Ir a traspaso de vacaciones",
    "rollover": "Traspaso",
    "confirm-dialog": {
      "title": "¿Está seguro?",
      "description-1": "Esto realizará el traspaso de vacaciones para toda la empresa. Se traspasarán los permisos no utilizados de {{previousYear}} a {{currentYear}}.",
      "description-2": "No podrá ejecutar el traspaso a nivel de empresa de nuevo para este año.",
      "description-3": "Puede actualizar el traspaso de un usuario individual y otras asignaciones a través de 'Editar asignaciones de vacaciones individuales'.",
      "continue": "Sí, traspasar permisos",
      "cancel": "No, aún no estoy listo"
    },
    "title": "Asignación de permisos",
    "basic": "Asignación básica",
    "just-additional": "Adicional",
    "current-carryover": "Traspaso actual",
    "updated": "Actualizado",
    "projected-total": "Total previsto para {{year}}",
    "unused-allowance": "Asignación no utilizada de {{year}}",
    "days-to-carry-over": "Días a traspasar a {{year}}`",
    "additional": "+ Días adicionales",
    "carried-over": "+ Traspasado",
    "total": "Total",
    "used": "Usado",
    "remaining": "Restante",
    "remaining-days": "Días restantes",
    "standard-remaining-days": "Días estándar restantes",
    "total-days-booked": "Total de días laborables reservados",
    "carry-over-remaining": "Traspaso restante",
    "justDays": "Días",
    "days": "{{days}} Días",
    "breakdown-basic": "Asignación básica",
    "breakdown-additional": "Días adicionales",
    "breakdown-carried-over": "Traspasado del año anterior",
    "breakdown-expires": "Caduca el: {{date}}",
    "breakdown-total": "Asignación total de vacaciones",
    "breakdown-total-expiry-tooltip": "La asignación total incluye días que pueden caducar",
    "holiday-carry-over-has-been-run": "El traspaso automático a nivel de empresa ya se ha ejecutado para este año de vacaciones.<br>Aún puede editar las asignaciones individuales o contactarnos para ejecutar el traspaso a nivel de empresa de nuevo.",
    "holiday-carry-over-info": {
      "info": "El informe de traspaso de vacaciones muestra una vista previa de los días traspasados para el próximo año. Pulse <strong>Confirmar</strong> en la parte inferior de la pantalla para aplicar las asignaciones actualizadas para todos los usuarios.",
      "expiry-info": "El informe de vencimiento de vacaciones muestra una vista previa de los días que van a vencer. Pulse <strong>Confirmar vencimiento</strong> en la parte inferior de la pantalla para aplicar las asignaciones actualizadas para todos los usuarios.",
      "carry-over-left": "El límite máximo de traspaso es de {{carryOverDays}} días.",
      "leave-settings": "Para ajustar esto, vaya a <0>Configuración de permisos</0>.",
      "carry-over-expires": "El traspaso vence el {{carryOverExpiryDate}}",
      "carry-over-does-not-expire": "El traspaso no vence",
      "view-report": "Ver informe",
      "carry-over-days-title-additional": "Incluye {{additionalDays}} días adicionales.",
      "carry-over-days-title-carry": "Incluye {{carriedOverDays}} días traspasados.",
      "carry-over-days-explanation": "Para ajustar esto, vaya a las asignaciones individuales",
      "days-to-carry-over-column-alert-title": "Actualmente configurado para traspasar {{carryOverDays}} días.",
      "days-to-carry-over-column-alert-explanation": "Si estos números son diferentes, se han añadido permisos desde la última ejecución del informe de traspaso.",
      "carry-over-report-title": "Informe de traspaso de vacaciones"
    },
    "holiday-expiry-info": {
      "carry-over-left": "El límite máximo de traspaso es de {{carryOverDays}} días.",
      "leave-settings": "Para ajustar esto, vaya a <0>Configuración de permisos</0>.",
      "carry-over-expires": "El traspaso vence el {{carryOverExpiryDate}}",
      "carry-over-does-not-expire": "El traspaso no vence",
      "view-report": "Ver informe",
      "carry-over-days-title": "Incluye {{additionalDays}} días adicionales.",
      "carry-over-days-explanation": "Para ajustar esto, vaya a las asignaciones individuales"
    }
  },
  "leave-type-dialog": {
    "title": "Elegir tipo de permiso"
  },
  "languages": {
    "english": "Inglés",
    "french": "Francés",
    "german": "Alemán",
    "spanish": "Español"
  },
  "calendar-sync": {
    "turn-on": "Activar",
    "active": "Sincronización de calendario activa",
    "loading": "Cargando sincronización de calendario",
    "none": "Sin sincronización de calendario",
    "disabled": "Sincronización de calendario desactivada",
    "unknown": "Estado desconocido"
  },
  "whereabouts-labels": {
    "COMPANY_HOLIDAY": "Vacaciones de empresa",
    "HOLIDAY_REJECTED": "Vacaciones (Rechazadas)",
    "HOLIDAY_APPROVED": "Vacaciones (Aprobadas)",
    "NOT_WORKING": "Día no laborable",
    "UNKNOWN": "Desconocido",
    "HOLIDAY": "Vacaciones",
    "HOLIDAY_PENDING": "Vacaciones (Pendiente)",
    "HOME": "Trabajando desde casa",
    "OFFICE": "En la oficina"
  },
  "user-hover": {
    "add-favourites": "Añadir a favoritos",
    "remove-favourites": "Eliminar de favoritos",
    "leave": "Ver permisos"
  },
  "hospitality": {
    "add-from-menu": "Añadir artículos del menú",
    "add-instructions": "Añadir instrucciones",
    "add-special-items": "Añadir artículos especiales",
    "confirm-instructions": "Confirmar instrucciones",
    "instructions-title": "Añadir instrucciones",
    "instructions-description": "Añadir notas (ej. preferencias alimentarias)",
    "cost-center": "Centro de costes",
    "choose-items": "Elegir artículos del menú",
    "confirm": "Confirmar elecciones",
    "add-item": "Añadir artículo",
    "special-hospitality-item-title": "Añadir artículo especial de hospitalidad",
    "food-cost": "Coste de comida (€)",
    "quantity": "Cantidad",
    "delivery": "Entrega",
    "item": "Artículo",
    "total-cost": "Coste total",
    "no-items": "No se han añadido artículos a esta reunión.",
    "not-started": "No iniciado",
    "in-progress": "En curso",
    "done": "Hecho",
    "report-day": "Descargar informe del día.csv",
    "report-week": "Descargar informe de la semana.csv",
    "report-month": "Descargar informe del mes.csv",
    "no-bookings": "Sin reservas de hospitalidad",
    "no-bookings-description": "Añada hospitalidad al reservar una reunión",
    "add-visitor": {
      "title": "Añadir visitante",
      "add-visitor": "Añadir visitante",
      "company": "Nombre de la empresa",
      "email": "Dirección de correo (solo si se envía invitación directamente)",
      "due-in": "Esperado a las",
      "meeting-with": "Reunión con"
    }
  }
}
